export default function Logo() {
  return (
    <>
      <svg
        width="150"
        height="60"
        viewBox="20 50 363 127"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M342.63 159.813L328.783 120.099L314.915 159.813H300.119L273.029 80.6006H294.338L307.732 119.731L321.407 80.6006H336.159L349.899 119.882L363.314 80.6006H384.538L357.448 159.813H342.63Z"
          fill="url(#paint0_linear_1886_6847)"
        />
        <path
          d="M342.415 159.598L328.568 119.883L314.7 159.598H299.904L272.814 80.3855H294.124L307.518 119.516L321.192 80.3855H335.945L349.684 119.667L363.1 80.3855H384.323L357.233 159.598H342.415Z"
          fill="url(#paint1_linear_1886_6847)"
        />
        <path
          d="M342.201 159.38L328.354 119.666L314.485 159.38H299.689L272.599 80.1675H293.909L307.303 119.298L320.977 80.1675H335.73L349.469 119.449L362.885 80.1675H384.108L357.018 159.38H342.201Z"
          fill="url(#paint2_linear_1886_6847)"
        />
        <path
          d="M341.983 159.165L328.136 119.45L314.268 159.165H299.472L272.382 79.9524H293.692L307.086 119.083L320.76 79.9524H335.513L349.252 119.234L362.667 79.9524H383.891L356.801 159.165H341.983Z"
          fill="url(#paint3_linear_1886_6847)"
        />
        <path
          d="M341.769 158.948L327.922 119.234L314.053 158.948H299.257L272.167 79.7358H293.477L306.871 118.866L320.545 79.7358H335.298L349.037 119.018L362.453 79.7358H383.676L356.586 158.948H341.769Z"
          fill="url(#paint4_linear_1886_6847)"
        />
        <path
          d="M341.554 158.731L327.707 119.017L313.839 158.731H299.043L271.953 79.5193H293.262L306.656 118.65L320.331 79.5193H335.083L348.823 118.801L362.238 79.5193H383.461L356.372 158.731H341.554Z"
          fill="url(#paint5_linear_1886_6847)"
        />
        <path
          d="M341.337 158.516L327.49 118.802L313.621 158.516H298.825L271.735 79.3042H293.045L306.439 118.435L320.113 79.3042H334.866L348.605 118.586L362.021 79.3042H383.244L356.154 158.516H341.337Z"
          fill="url(#paint6_linear_1886_6847)"
        />
        <path
          d="M341.122 158.3L327.275 118.586L313.406 158.3H298.61L271.521 79.0876H292.83L306.224 118.218L319.898 79.0876H334.651L348.39 118.369L361.806 79.0876H383.029L355.939 158.3H341.122Z"
          fill="url(#paint7_linear_1886_6847)"
        />
        <path
          d="M340.907 158.083L327.06 118.369L313.192 158.083H298.396L271.306 78.8711H292.615L306.009 118.002L319.684 78.8711H334.437L348.176 118.153L361.591 78.8711H382.815L355.725 158.083H340.907Z"
          fill="url(#paint8_linear_1886_6847)"
        />
        <path
          d="M340.69 157.867L326.843 118.153L312.974 157.867H298.178L271.088 78.6545H292.398L305.792 117.785L319.466 78.6545H334.219L347.958 117.936L361.374 78.6545H382.597L355.507 157.867H340.69Z"
          fill="url(#paint9_linear_1886_6847)"
        />
        <path
          d="M340.475 157.652L326.628 117.937L312.76 157.652H297.964L270.874 78.4395H292.183L305.577 117.57L319.252 78.4395H334.004L347.744 117.721L361.159 78.4395H382.383L355.293 157.652H340.475Z"
          fill="url(#paint10_linear_1886_6847)"
        />
        <path
          d="M340.258 157.435L326.411 117.721L312.542 157.435H297.746L270.656 78.2229H291.966L305.36 117.353L319.034 78.2229H333.787L347.526 117.505L360.942 78.2229H382.165L355.075 157.435H340.258Z"
          fill="url(#paint11_linear_1886_6847)"
        />
        <path
          d="M340.043 157.219L326.196 117.504L312.328 157.219H297.532L270.442 78.0063H291.751L305.145 117.137L318.82 78.0063H333.572L347.312 117.288L360.727 78.0063H381.95L354.86 157.219H340.043Z"
          fill="url(#paint12_linear_1886_6847)"
        />
        <path
          d="M339.828 157.002L325.981 117.288L312.113 157.002H297.317L270.227 77.7898H291.537L304.931 116.92L318.605 77.7898H333.358L347.097 117.072L360.512 77.7898H381.736L354.646 157.002H339.828Z"
          fill="url(#paint13_linear_1886_6847)"
        />
        <path
          d="M339.611 156.787L325.764 117.073L311.895 156.787H297.099L270.01 77.5747H291.319L304.713 116.705L318.387 77.5747H333.14L346.879 116.856L360.295 77.5747H381.518L354.428 156.787H339.611Z"
          fill="url(#paint14_linear_1886_6847)"
        />
        <path
          d="M339.396 156.57L325.549 116.856L311.681 156.57H296.885L269.795 77.3582H291.104L304.498 116.489L318.173 77.3582H332.926L346.665 116.64L360.08 77.3582H381.304L354.214 156.57H339.396Z"
          fill="url(#paint15_linear_1886_6847)"
        />
        <path
          d="M339.182 156.354L325.335 116.64L311.466 156.354H296.67L269.58 77.1418H290.89L304.284 116.272L317.958 77.1418H332.711L346.45 116.424L359.866 77.1418H381.089L353.999 156.354H339.182Z"
          fill="url(#paint16_linear_1886_6847)"
        />
        <path
          d="M338.964 156.138L325.117 116.423L311.249 156.138H296.453L269.363 76.9253H290.672L304.066 116.056L317.741 76.9253H332.493L346.233 116.207L359.648 76.9253H380.871L353.782 156.138H338.964Z"
          fill="url(#paint17_linear_1886_6847)"
        />
        <path
          d="M338.749 155.922L324.902 116.208L311.034 155.922H296.238L269.148 76.7102H290.458L303.852 115.841L317.526 76.7102H332.279L346.018 115.992L359.433 76.7102H380.657L353.567 155.922H338.749Z"
          fill="url(#paint18_linear_1886_6847)"
        />
        <path
          d="M338.535 155.706L324.688 115.992L310.819 155.706H296.023L268.933 76.4937H290.243L303.637 115.624L317.311 76.4937H332.064L345.803 115.775L359.219 76.4937H380.442L353.352 155.706H338.535Z"
          fill="url(#paint19_linear_1886_6847)"
        />
        <path
          d="M338.317 155.489L324.47 115.775L310.602 155.489H295.806L268.716 76.2771H290.026L303.42 115.408L317.094 76.2771H331.847L345.586 115.559L359.001 76.2771H380.225L353.135 155.489H338.317Z"
          fill="url(#paint20_linear_1886_6847)"
        />
        <path
          d="M338.103 155.273L324.256 115.559L310.387 155.273H295.591L268.501 76.0605H289.811L303.205 115.191L316.879 76.0605H331.632L345.371 115.342L358.787 76.0605H380.01L352.92 155.273H338.103Z"
          fill="url(#paint21_linear_1886_6847)"
        />
        <path
          d="M337.885 155.056L324.038 115.342L310.17 155.056H295.374L268.284 75.844H289.593L302.987 114.974L316.662 75.844H331.415L345.154 115.126L358.569 75.844H379.793L352.703 155.056H337.885Z"
          fill="url(#paint22_linear_1886_6847)"
        />
        <path
          d="M337.671 154.841L323.824 115.127L309.955 154.841H295.159L268.069 75.6289H289.379L302.773 114.759L316.447 75.6289H331.2L344.939 114.911L358.355 75.6289H379.578L352.488 154.841H337.671Z"
          fill="url(#paint23_linear_1886_6847)"
        />
        <path
          d="M337.456 154.625L323.609 114.91L309.74 154.625H294.944L267.855 75.4124H289.164L302.558 114.543L316.233 75.4124H330.985L344.724 114.694L358.14 75.4124H379.363L352.273 154.625H337.456Z"
          fill="url(#paint24_linear_1886_6847)"
        />
        <path
          d="M337.238 154.408L323.391 114.694L309.523 154.408H294.727L267.637 75.1958H288.947L302.341 114.326L316.015 75.1958H330.768L344.507 114.478L357.923 75.1958H379.146L352.056 154.408H337.238Z"
          fill="url(#paint25_linear_1886_6847)"
        />
        <path
          d="M337.238 154.407L323.391 114.693L309.523 154.407H294.727L267.637 75.1953H288.946L302.34 114.326L316.015 75.1953H330.768L344.507 114.477L357.922 75.1953H379.146L352.056 154.407H337.238Z"
          fill="url(#paint26_linear_1886_6847)"
        />
        <path
          d="M338.338 152.873L323.391 110.045L308.444 152.873H295.827L269.772 76.7305H287.847L302.319 119.017L317.093 76.7305H329.668L344.528 119.169L359.001 76.7305H377.01L350.956 152.873H338.338Z"
          fill="url(#paint27_linear_1886_6847)"
        />
        <path
          d="M288.839 79.6274L287.847 76.7305H269.772L295.827 152.873H297.725L272.662 79.6274H288.839ZM329.668 76.7305H317.093L303.268 116.272L305.209 121.914L319.984 79.6274H330.682L329.668 76.7305ZM325.333 115.645L338.317 152.873H340.193L326.26 112.942L325.311 115.645H325.333ZM359.001 76.7305L345.456 116.466L347.419 122.087L361.891 79.6274H375.997L376.989 76.7305H359.001Z"
          fill="url(#paint28_linear_1886_6847)"
        />
        <rect
          x="198.963"
          y="1.9082"
          width="248.037"
          height="224.838"
          fill="url(#pattern0_1886_6847)"
        />
        <path
          d="M282.392 88.513C281.659 88.513 280.926 88.2103 280.408 87.6914C280.279 87.5617 280.149 87.4103 280.063 87.259C279.977 87.1077 279.869 86.9347 279.804 86.7834C279.74 86.6104 279.675 86.4375 279.632 86.2646C279.589 86.0916 279.567 85.897 279.567 85.7241C279.567 85.5511 279.567 85.3565 279.632 85.162C279.675 84.989 279.718 84.7945 279.783 84.6431C279.847 84.4702 279.934 84.3188 280.041 84.1675C280.149 84.0162 280.257 83.8648 280.387 83.7351C280.516 83.6054 280.667 83.4757 280.818 83.3893C280.969 83.2812 281.141 83.1946 281.292 83.1298C281.465 83.0649 281.638 83.0001 281.81 82.9568C282.177 82.892 282.543 82.892 282.91 82.9568C283.083 83.0001 283.277 83.0433 283.428 83.1298C283.6 83.1946 283.751 83.2812 283.902 83.3893C284.053 83.4973 284.204 83.6054 284.334 83.7351C284.851 84.254 285.153 84.989 285.153 85.7241C285.153 85.897 285.153 86.0916 285.088 86.2646C285.045 86.4375 285.002 86.6321 284.937 86.7834C284.873 86.9563 284.787 87.1077 284.679 87.259C284.571 87.4103 284.463 87.5617 284.334 87.6914C284.204 87.8211 284.053 87.9292 283.902 88.0373C283.751 88.1454 283.579 88.2319 283.428 88.2968C283.255 88.3616 283.083 88.4265 282.91 88.4481C282.716 88.4913 282.543 88.513 282.349 88.513H282.392Z"
          fill="#FFE0A9"
        />
        <path
          d="M296.283 134.973C295.787 133.503 296.563 131.903 298.03 131.406C299.496 130.909 301.092 131.687 301.588 133.157C302.084 134.627 301.308 136.227 299.841 136.724C299.539 136.833 299.238 136.876 298.936 136.876C297.771 136.876 296.692 136.141 296.283 134.973ZM292.961 125.288C292.465 123.818 293.241 122.218 294.708 121.721C296.175 121.224 297.771 122.002 298.267 123.472C298.763 124.942 297.987 126.542 296.52 127.039C296.218 127.147 295.916 127.19 295.614 127.19C294.449 127.19 293.371 126.455 292.961 125.288ZM289.661 115.624C289.165 114.154 289.941 112.554 291.408 112.057C292.875 111.56 294.471 112.338 294.967 113.808C295.463 115.278 294.687 116.878 293.22 117.375C292.918 117.484 292.616 117.527 292.314 117.527C291.149 117.527 290.071 116.792 289.661 115.624ZM286.361 105.939C285.865 104.469 286.641 102.869 288.108 102.372C289.575 101.875 291.171 102.653 291.667 104.123C292.163 105.593 291.387 107.193 289.92 107.69C289.618 107.798 289.316 107.841 289.014 107.841C287.849 107.841 286.771 107.106 286.361 105.939ZM283.04 96.2753C282.544 94.8052 283.32 93.2054 284.787 92.7081C286.253 92.2109 287.849 92.9892 288.345 94.4593C288.842 95.9294 288.065 97.5292 286.598 98.0264C286.296 98.1345 285.994 98.1777 285.692 98.1777C284.528 98.1777 283.449 97.4427 283.04 96.2753Z"
          fill="#FFE0A9"
        />
        <path
          d="M302.234 146.539C301.501 146.539 300.767 146.236 300.25 145.717C300.12 145.588 300.012 145.436 299.904 145.285C299.797 145.134 299.71 144.961 299.646 144.809C299.581 144.637 299.516 144.464 299.495 144.291C299.451 144.118 299.43 143.923 299.43 143.75C299.43 143.015 299.732 142.28 300.25 141.761C300.767 141.242 301.501 140.94 302.234 140.94C302.967 140.94 303.7 141.242 304.218 141.761C304.736 142.28 305.038 143.015 305.038 143.75C305.038 144.485 304.736 145.22 304.218 145.739C303.7 146.258 302.967 146.561 302.234 146.561V146.539Z"
          fill="#FFE0A9"
        />
        <path
          d="M304.802 136.702C303.357 136.162 302.602 134.562 303.12 133.092C303.659 131.643 305.255 130.887 306.722 131.406C308.188 131.946 308.922 133.546 308.404 135.016C307.994 136.162 306.916 136.854 305.773 136.854C305.449 136.854 305.126 136.789 304.802 136.681V136.702ZM308.318 127.017C306.873 126.476 306.118 124.877 306.635 123.406C307.175 121.936 308.771 121.201 310.237 121.72C311.682 122.261 312.437 123.86 311.92 125.331C311.51 126.476 310.431 127.19 309.288 127.19C308.965 127.19 308.641 127.125 308.318 127.017ZM311.855 117.353C310.388 116.813 309.655 115.213 310.173 113.743C310.712 112.294 312.308 111.538 313.775 112.056C315.22 112.597 315.975 114.197 315.457 115.667C315.047 116.813 313.969 117.526 312.826 117.526C312.502 117.526 312.178 117.461 311.877 117.353H311.855ZM315.371 107.689C313.926 107.149 313.171 105.549 313.688 104.079C314.227 102.631 315.824 101.874 317.29 102.393C318.757 102.933 319.49 104.533 318.973 106.003C318.563 107.149 317.484 107.841 316.341 107.841C316.018 107.841 315.694 107.776 315.371 107.668V107.689ZM318.908 98.0041C317.463 97.4636 316.708 95.8638 317.225 94.3937C317.765 92.9236 319.361 92.1886 320.827 92.7074C322.272 93.2479 323.027 94.8477 322.51 96.3178C322.1 97.4636 321.022 98.1771 319.878 98.1771C319.555 98.1771 319.231 98.1122 318.908 98.0041Z"
          fill="#FFE0A9"
        />
        <path
          d="M323.394 88.5136C323.2 88.5136 323.027 88.5136 322.855 88.4487C322.682 88.4055 322.488 88.3623 322.337 88.2974C322.165 88.2325 322.014 88.1461 321.863 88.038C321.712 87.9299 321.561 87.8218 321.431 87.6921C320.914 87.1732 320.612 86.4381 320.612 85.7031C320.612 84.968 320.914 84.233 321.431 83.7142C321.561 83.5845 321.712 83.4547 321.863 83.3683C322.014 83.2602 322.186 83.1737 322.337 83.1088C322.51 83.044 322.682 82.9791 322.855 82.9358C323.221 82.871 323.588 82.871 323.955 82.9358C324.127 82.9791 324.3 83.0224 324.472 83.1088C324.645 83.1737 324.796 83.2602 324.947 83.3683C325.098 83.4764 325.249 83.5845 325.378 83.7142C325.508 83.8439 325.637 83.9952 325.723 84.1465C325.81 84.2978 325.918 84.4708 325.982 84.6221C326.047 84.7951 326.112 84.9681 326.155 85.141C326.198 85.3356 326.198 85.5085 326.198 85.7031C326.198 85.8977 326.198 86.0706 326.155 86.2436C326.112 86.4165 326.068 86.6111 325.982 86.7625C325.918 86.9354 325.831 87.0868 325.723 87.2381C325.615 87.3894 325.508 87.5407 325.378 87.6704C324.861 88.1893 324.127 88.492 323.394 88.492V88.5136Z"
          fill="#FFE0A9"
        />
        <path
          d="M338.447 135.168C337.908 133.719 338.663 132.098 340.108 131.557C341.575 131.017 343.171 131.774 343.71 133.222C344.249 134.692 343.494 136.292 342.028 136.833C341.704 136.941 341.381 137.005 341.057 137.005C339.914 137.005 338.836 136.292 338.426 135.168H338.447ZM334.91 125.461C334.371 123.991 335.126 122.391 336.592 121.85C338.037 121.31 339.655 122.067 340.194 123.537C340.734 124.985 339.979 126.607 338.534 127.147C338.21 127.255 337.887 127.32 337.563 127.32C336.42 127.32 335.341 126.607 334.932 125.483L334.91 125.461ZM331.373 115.754C330.834 114.305 331.589 112.684 333.055 112.144C334.5 111.603 336.118 112.36 336.657 113.83C337.196 115.278 336.441 116.9 334.996 117.44C334.673 117.548 334.349 117.613 334.026 117.613C332.883 117.613 331.804 116.9 331.394 115.754H331.373ZM327.836 106.069C327.296 104.62 328.051 102.999 329.518 102.458C330.963 101.918 332.581 102.674 333.12 104.123C333.659 105.593 332.904 107.193 331.438 107.733C331.114 107.841 330.791 107.906 330.489 107.906C329.345 107.906 328.267 107.193 327.857 106.069H327.836ZM324.298 96.3616C323.759 94.8915 324.514 93.2917 325.981 92.7512C327.426 92.2108 329.043 92.9674 329.583 94.4159C330.122 95.8644 329.367 97.4858 327.9 98.0263C327.577 98.1344 327.253 98.1992 326.93 98.1992C325.787 98.1992 324.708 97.4858 324.298 96.3616Z"
          fill="#FFE0A9"
        />
        <path
          d="M344.617 146.713C343.883 146.713 343.15 146.41 342.632 145.891C342.503 145.761 342.395 145.61 342.287 145.459C342.179 145.307 342.093 145.135 342.028 144.983C341.964 144.81 341.899 144.637 341.878 144.464C341.834 144.291 341.813 144.097 341.813 143.924C341.813 143.189 342.115 142.454 342.632 141.935C343.279 141.286 344.25 140.984 345.177 141.157C345.35 141.2 345.523 141.243 345.695 141.33C345.868 141.394 346.019 141.481 346.17 141.589C346.321 141.697 346.472 141.805 346.601 141.935C347.119 142.454 347.421 143.189 347.421 143.924C347.421 144.659 347.119 145.394 346.601 145.913C346.083 146.432 345.35 146.734 344.617 146.734V146.713Z"
          fill="#FFE0A9"
        />
        <path
          d="M347.033 136.854C345.566 136.356 344.789 134.757 345.286 133.286C345.782 131.816 347.378 131.038 348.844 131.535C350.311 132.033 351.087 133.632 350.591 135.102C350.203 136.27 349.103 137.005 347.938 137.005C347.637 137.005 347.335 136.962 347.033 136.854ZM350.333 127.147C348.866 126.649 348.089 125.05 348.586 123.58C349.082 122.109 350.678 121.331 352.144 121.828C353.611 122.326 354.387 123.925 353.891 125.396C353.503 126.563 352.403 127.298 351.238 127.298C350.936 127.298 350.634 127.255 350.333 127.147ZM353.654 117.461C352.187 116.964 351.411 115.364 351.907 113.894C352.403 112.424 353.999 111.646 355.466 112.143C356.932 112.64 357.709 114.24 357.213 115.71C356.825 116.878 355.725 117.613 354.56 117.613C354.258 117.613 353.956 117.569 353.654 117.461ZM356.954 107.754C355.487 107.257 354.711 105.657 355.207 104.187C355.703 102.717 357.299 101.939 358.766 102.436C360.232 102.933 361.009 104.533 360.513 106.003C360.125 107.171 359.025 107.906 357.86 107.906C357.558 107.906 357.256 107.862 356.954 107.754ZM360.276 98.0475C358.809 97.5502 358.033 95.9504 358.529 94.4803C359.025 93.0102 360.621 92.2319 362.087 92.7291C363.554 93.2264 364.33 94.8262 363.834 96.2963C363.446 97.4637 362.346 98.1987 361.181 98.1987C360.879 98.1987 360.578 98.1555 360.276 98.0475Z"
          fill="#FFE0A9"
        />
        <path
          d="M364.482 88.5142C363.749 88.5142 363.016 88.2115 362.498 87.6927C362.369 87.5629 362.261 87.4116 362.153 87.2602C362.045 87.1089 361.959 86.936 361.894 86.7846C361.83 86.6117 361.765 86.4387 361.743 86.2658C361.7 86.0928 361.679 85.8983 361.679 85.7253C361.679 85.5524 361.679 85.3578 361.743 85.1632C361.786 84.9902 361.83 84.7957 361.894 84.6444C361.959 84.4714 362.045 84.3201 362.153 84.1687C362.261 84.0174 362.369 83.866 362.498 83.7363C362.628 83.6066 362.779 83.477 362.93 83.3905C363.081 83.2824 363.253 83.1959 363.404 83.131C363.577 83.0661 363.749 83.0013 363.922 82.9581C364.828 82.7851 365.798 83.0661 366.445 83.7363C366.963 84.2552 367.265 84.9903 367.265 85.7253C367.265 85.8983 367.265 86.0928 367.2 86.2658C367.157 86.4387 367.114 86.6333 367.049 86.7846C366.984 86.9576 366.898 87.1089 366.79 87.2602C366.682 87.4116 366.575 87.5629 366.445 87.6927C365.928 88.2115 365.194 88.5142 364.461 88.5142H364.482Z"
          fill="#FFE0A9"
        />
        <path
          d="M282.391 87.4755C281.916 87.4755 281.463 87.281 281.14 86.9567C281.053 86.8702 280.989 86.7837 280.924 86.6756C280.859 86.5675 280.816 86.481 280.751 86.3729C280.708 86.2648 280.665 86.1568 280.644 86.0271C280.644 85.919 280.6 85.7892 280.6 85.6811C280.6 85.2055 280.794 84.7515 281.118 84.4056C281.528 83.9949 282.153 83.8003 282.736 83.9084C282.843 83.93 282.951 83.9732 283.059 84.0164C283.167 84.0597 283.275 84.1246 283.361 84.1894C283.447 84.2543 283.555 84.3192 283.642 84.4056C283.965 84.7299 284.159 85.2055 284.159 85.6811C284.159 85.7892 284.159 85.919 284.116 86.0271C284.116 86.1352 284.051 86.2432 284.03 86.3729C283.987 86.481 283.922 86.5891 283.857 86.6756C283.792 86.7621 283.728 86.8702 283.642 86.9567C283.555 87.0431 283.469 87.108 283.361 87.1729C283.275 87.2377 283.167 87.2809 283.059 87.3458C282.951 87.389 282.843 87.4322 282.736 87.4539C282.628 87.4539 282.498 87.4971 282.391 87.4971V87.4755Z"
          fill="#FFEDD2"
        />
        <path
          d="M297.251 134.626C296.928 133.696 297.424 132.68 298.373 132.356C299.3 132.032 300.314 132.529 300.638 133.458C300.961 134.388 300.465 135.404 299.516 135.728C299.322 135.793 299.128 135.815 298.934 135.815C298.2 135.815 297.51 135.339 297.251 134.604V134.626ZM293.93 124.962C293.606 124.033 294.102 123.016 295.051 122.692C295.979 122.368 296.993 122.865 297.316 123.816C297.64 124.746 297.144 125.762 296.194 126.086C296 126.151 295.806 126.194 295.612 126.194C294.857 126.194 294.167 125.719 293.93 124.984V124.962ZM290.63 115.298C290.306 114.369 290.802 113.353 291.73 113.028C292.657 112.704 293.671 113.201 293.995 114.153C294.318 115.082 293.822 116.098 292.873 116.423C292.679 116.487 292.485 116.531 292.291 116.531C291.536 116.531 290.846 116.055 290.608 115.32L290.63 115.298ZM287.308 105.613C286.985 104.683 287.481 103.667 288.408 103.343C289.336 103.019 290.349 103.516 290.673 104.446C290.997 105.375 290.5 106.391 289.551 106.716C289.357 106.78 289.163 106.802 288.969 106.802C288.214 106.802 287.546 106.327 287.287 105.591L287.308 105.613ZM284.008 95.9494C283.685 95.0198 284.181 94.0036 285.13 93.6794C286.057 93.3551 287.071 93.8523 287.395 94.8036C287.718 95.7332 287.222 96.7493 286.295 97.0736C286.1 97.1384 285.906 97.1601 285.712 97.1601C284.979 97.1601 284.289 96.6844 284.03 95.9494H284.008Z"
          fill="#FFEDD2"
        />
        <path
          d="M302.234 145.522C302.126 145.522 301.997 145.522 301.889 145.479C301.781 145.457 301.673 145.414 301.544 145.371C301.436 145.328 301.328 145.263 301.242 145.198C301.156 145.133 301.048 145.047 300.962 144.982C300.638 144.657 300.444 144.182 300.444 143.728C300.444 143.274 300.638 142.798 300.962 142.452C301.371 142.041 301.997 141.847 302.579 141.955C302.687 141.977 302.795 142.02 302.903 142.063C303.011 142.106 303.118 142.171 303.205 142.236C303.291 142.301 303.399 142.366 303.485 142.452C303.809 142.776 304.003 143.252 304.003 143.728C304.003 144.203 303.809 144.657 303.485 144.982C303.399 145.068 303.313 145.133 303.205 145.198C303.118 145.263 303.011 145.306 302.903 145.371C302.795 145.414 302.687 145.457 302.579 145.479C302.471 145.479 302.342 145.522 302.234 145.522Z"
          fill="white"
        />
        <path
          d="M305.146 135.729C304.218 135.383 303.744 134.367 304.089 133.438C304.434 132.508 305.448 132.032 306.375 132.378C307.302 132.724 307.777 133.74 307.432 134.67C307.173 135.405 306.483 135.837 305.75 135.837C305.555 135.837 305.34 135.794 305.124 135.729H305.146ZM308.683 126.066C307.755 125.72 307.281 124.704 307.626 123.774C307.971 122.844 308.985 122.369 309.912 122.715C310.84 123.06 311.314 124.077 310.969 125.006C310.71 125.741 310.02 126.174 309.287 126.174C309.093 126.174 308.877 126.152 308.683 126.066ZM312.198 116.38C311.271 116.034 310.797 115.018 311.142 114.089C311.487 113.159 312.5 112.683 313.428 113.029C314.355 113.375 314.83 114.391 314.485 115.321C314.226 116.056 313.536 116.488 312.802 116.488C312.608 116.488 312.393 116.445 312.198 116.38ZM315.714 106.716C314.787 106.371 314.312 105.354 314.657 104.425C315.002 103.495 316.016 103.02 316.944 103.366C317.871 103.711 318.345 104.728 318 105.657C317.742 106.392 317.051 106.825 316.318 106.825C316.124 106.825 315.908 106.781 315.714 106.716ZM319.251 97.0527C318.324 96.7068 317.849 95.6907 318.195 94.7611C318.54 93.8315 319.553 93.3559 320.481 93.7018C321.408 94.0477 321.883 95.0638 321.538 95.9934C321.279 96.7068 320.589 97.1609 319.855 97.1609C319.661 97.1609 319.445 97.1176 319.251 97.0527Z"
          fill="white"
        />
        <path
          d="M323.393 87.4759C323.285 87.4759 323.155 87.4759 323.048 87.4327C322.94 87.4111 322.832 87.3678 322.703 87.3246C322.595 87.2813 322.487 87.2165 322.401 87.1516C322.314 87.0868 322.206 87.0003 322.12 86.9354C322.034 86.8706 321.969 86.7625 321.905 86.6544C321.84 86.5463 321.797 86.4598 321.732 86.3517C321.689 86.2436 321.646 86.1355 321.624 86.0058C321.624 85.8977 321.581 85.768 321.581 85.6599C321.581 85.1843 321.775 84.7303 322.099 84.3844C322.508 83.9736 323.134 83.779 323.716 83.8871C323.824 83.9087 323.932 83.952 324.04 83.9953C324.148 84.0385 324.255 84.1033 324.342 84.1682C324.428 84.233 324.536 84.2979 324.622 84.3844C324.946 84.7087 325.14 85.1843 325.14 85.6599C325.14 85.768 325.14 85.8977 325.097 86.0058C325.097 86.1139 325.032 86.222 324.989 86.3517C324.946 86.4598 324.881 86.5679 324.816 86.6544C324.752 86.7408 324.687 86.8489 324.601 86.9354C324.514 87.0219 324.428 87.0868 324.32 87.1516C324.234 87.2165 324.126 87.2597 324.018 87.3246C323.91 87.3678 323.802 87.4111 323.695 87.4327C323.587 87.4327 323.457 87.4759 323.35 87.4759H323.393Z"
          fill="white"
        />
        <path
          d="M339.419 134.82C339.073 133.891 339.548 132.875 340.475 132.529C341.403 132.183 342.417 132.68 342.762 133.588C343.107 134.518 342.632 135.555 341.705 135.88C341.511 135.966 341.295 135.988 341.101 135.988C340.368 135.988 339.699 135.534 339.419 134.82ZM335.881 125.113C335.536 124.184 336.011 123.146 336.938 122.822C337.866 122.476 338.879 122.951 339.224 123.881C339.57 124.811 339.095 125.827 338.168 126.173C337.974 126.238 337.758 126.281 337.564 126.281C336.83 126.281 336.162 125.827 335.881 125.113ZM332.323 115.406C331.977 114.477 332.452 113.439 333.379 113.115C334.307 112.769 335.321 113.245 335.666 114.174C336.011 115.104 335.536 116.141 334.609 116.466C334.415 116.552 334.199 116.574 334.005 116.574C333.272 116.574 332.603 116.12 332.323 115.406ZM328.785 105.699C328.44 104.77 328.915 103.754 329.842 103.408C330.77 103.062 331.805 103.559 332.128 104.467C332.474 105.397 331.999 106.435 331.072 106.759C330.877 106.824 330.662 106.867 330.446 106.867C329.713 106.867 329.044 106.413 328.764 105.699H328.785ZM325.248 96.0142C324.903 95.0845 325.378 94.0685 326.305 93.7226C327.232 93.3766 328.268 93.8522 328.591 94.7819C328.936 95.7115 328.462 96.7276 327.534 97.0735C327.34 97.1383 327.125 97.1815 326.909 97.1815C326.176 97.1815 325.507 96.7276 325.227 96.0142H325.248Z"
          fill="white"
        />
        <path
          d="M344.614 145.695C344.506 145.695 344.377 145.695 344.269 145.673C344.161 145.651 344.032 145.608 343.924 145.565C343.816 145.522 343.708 145.457 343.622 145.392C343.536 145.327 343.428 145.241 343.342 145.176C343.018 144.851 342.824 144.376 342.824 143.922C342.824 143.468 343.018 142.992 343.342 142.646C343.428 142.56 343.514 142.495 343.622 142.43C343.708 142.365 343.816 142.3 343.924 142.257C344.032 142.214 344.14 142.171 344.269 142.149C344.851 142.041 345.477 142.236 345.887 142.646C345.973 142.733 346.038 142.819 346.102 142.927C346.167 143.014 346.232 143.122 346.275 143.23C346.318 143.338 346.361 143.446 346.383 143.554C346.404 143.662 346.426 143.792 346.426 143.9C346.426 144.008 346.426 144.138 346.383 144.246C346.383 144.354 346.318 144.462 346.275 144.592C346.232 144.7 346.189 144.808 346.102 144.895C346.038 145.003 345.973 145.089 345.887 145.176C345.8 145.262 345.714 145.327 345.606 145.392C345.52 145.457 345.412 145.5 345.304 145.565C345.196 145.608 345.089 145.651 344.981 145.673C344.873 145.673 344.744 145.695 344.636 145.695H344.614Z"
          fill="white"
        />
        <path
          d="M347.354 135.902C346.427 135.578 345.931 134.562 346.233 133.632C346.556 132.703 347.57 132.205 348.497 132.508C349.425 132.832 349.921 133.848 349.619 134.778C349.36 135.513 348.67 135.989 347.937 135.989C347.742 135.989 347.548 135.967 347.354 135.881V135.902ZM350.676 126.195C349.748 125.871 349.252 124.855 349.554 123.925C349.878 122.996 350.891 122.498 351.819 122.801C352.746 123.125 353.242 124.141 352.94 125.071C352.682 125.828 351.991 126.282 351.258 126.282C351.064 126.282 350.87 126.26 350.676 126.195ZM353.976 116.488C353.048 116.164 352.552 115.148 352.876 114.218C353.199 113.289 354.213 112.791 355.14 113.094C356.068 113.418 356.564 114.434 356.262 115.364C356.003 116.099 355.313 116.575 354.58 116.575C354.385 116.575 354.191 116.553 353.997 116.467L353.976 116.488ZM357.276 106.781C356.348 106.457 355.852 105.441 356.154 104.511C356.478 103.582 357.491 103.084 358.419 103.387C359.346 103.711 359.842 104.727 359.54 105.657C359.282 106.392 358.591 106.868 357.858 106.868C357.664 106.868 357.47 106.824 357.276 106.781ZM360.597 97.0743C359.67 96.75 359.174 95.734 359.476 94.8043C359.799 93.8747 360.813 93.3774 361.74 93.6801C362.668 94.0044 363.164 95.0205 362.84 95.9501C362.581 96.7068 361.891 97.1608 361.158 97.1608C360.964 97.1608 360.77 97.1391 360.576 97.0527L360.597 97.0743Z"
          fill="white"
        />
        <path
          d="M364.48 87.4746C364.005 87.4746 363.553 87.2801 363.229 86.9558C363.143 86.8693 363.078 86.7828 363.013 86.6747C362.949 86.5666 362.906 86.4801 362.841 86.372C362.798 86.2639 362.755 86.1559 362.733 86.0262C362.733 85.9181 362.69 85.7884 362.69 85.6803C362.69 85.5722 362.69 85.4424 362.733 85.3344C362.755 85.2263 362.798 85.1182 362.841 85.0101C362.884 84.902 362.949 84.7939 363.013 84.7074C363.078 84.6209 363.164 84.5128 363.229 84.4263C363.639 84.0156 364.264 83.821 364.825 83.9291C364.933 83.9507 365.062 83.994 365.17 84.0372C365.278 84.0804 365.386 84.1453 365.472 84.2101C365.58 84.275 365.666 84.3398 365.752 84.4263C366.076 84.7506 366.27 85.2262 366.27 85.7018C366.27 86.1775 366.076 86.6315 365.752 86.9558C365.407 87.2801 364.954 87.4746 364.48 87.4746Z"
          fill="white"
        />
        <path
          d="M227.679 159.077C204.709 159.077 187.389 141.933 187.389 119.212C187.389 96.4901 204.709 79.3462 227.679 79.3462C250.65 79.3462 267.969 96.4901 267.969 119.212C267.969 141.933 250.65 159.077 227.679 159.077ZM227.679 99.3871C215.968 99.3871 207.47 107.732 207.47 119.212C207.47 130.691 215.968 139.036 227.679 139.036C239.391 139.036 247.889 130.691 247.889 119.212C247.889 107.732 239.391 99.3871 227.679 99.3871Z"
          fill="url(#paint29_linear_1886_6847)"
        />
        <path
          d="M227.465 158.862C204.494 158.862 187.175 141.718 187.175 118.997C187.175 96.275 204.494 79.1311 227.465 79.1311C250.435 79.1311 267.755 96.275 267.755 118.997C267.755 141.718 250.435 158.862 227.465 158.862ZM227.465 99.1719C215.753 99.1719 207.255 107.517 207.255 118.997C207.255 130.476 215.753 138.821 227.465 138.821C239.176 138.821 247.674 130.476 247.674 118.997C247.674 107.517 239.176 99.1719 227.465 99.1719Z"
          fill="url(#paint30_linear_1886_6847)"
        />
        <path
          d="M227.25 158.646C204.28 158.646 186.96 141.502 186.96 118.78C186.96 96.0585 204.28 78.9146 227.25 78.9146C250.22 78.9146 267.54 96.0585 267.54 118.78C267.54 141.502 250.22 158.646 227.25 158.646ZM227.25 98.9554C215.538 98.9554 207.04 107.3 207.04 118.78C207.04 130.26 215.538 138.605 227.25 138.605C238.962 138.605 247.46 130.26 247.46 118.78C247.46 107.3 238.962 98.9554 227.25 98.9554Z"
          fill="url(#paint31_linear_1886_6847)"
        />
        <path
          d="M227.032 158.429C204.062 158.429 186.743 141.285 186.743 118.564C186.743 95.8419 204.062 78.698 227.032 78.698C250.003 78.698 267.322 95.8419 267.322 118.564C267.322 141.285 250.003 158.429 227.032 158.429ZM227.032 98.7388C215.321 98.7388 206.823 107.084 206.823 118.564C206.823 130.043 215.321 138.388 227.032 138.388C238.744 138.388 247.242 130.043 247.242 118.564C247.242 107.084 238.744 98.7388 227.032 98.7388Z"
          fill="url(#paint32_linear_1886_6847)"
        />
        <path
          d="M226.818 158.214C203.847 158.214 186.528 141.07 186.528 118.348C186.528 95.6268 203.847 78.4829 226.818 78.4829C249.788 78.4829 267.108 95.6268 267.108 118.348C267.108 141.07 249.788 158.214 226.818 158.214ZM226.818 98.5238C215.106 98.5238 206.608 106.869 206.608 118.348C206.608 129.828 215.106 138.173 226.818 138.173C238.529 138.173 247.027 129.828 247.027 118.348C247.027 106.869 238.529 98.5238 226.818 98.5238Z"
          fill="url(#paint33_linear_1886_6847)"
        />
        <path
          d="M226.603 157.997C203.633 157.997 186.313 140.854 186.313 118.132C186.313 95.4103 203.633 78.2664 226.603 78.2664C249.574 78.2664 266.893 95.4103 266.893 118.132C266.893 140.854 249.574 157.997 226.603 157.997ZM226.603 98.3073C214.892 98.3073 206.394 106.652 206.394 118.132C206.394 129.612 214.892 137.957 226.603 137.957C238.315 137.957 246.813 129.612 246.813 118.132C246.813 106.652 238.315 98.3073 226.603 98.3073Z"
          fill="url(#paint34_linear_1886_6847)"
        />
        <path
          d="M226.386 157.782C203.415 157.782 186.096 140.638 186.096 117.917C186.096 95.1952 203.415 78.0513 226.386 78.0513C249.356 78.0513 266.676 95.1952 266.676 117.917C266.676 140.638 249.356 157.782 226.386 157.782ZM226.386 98.0921C214.674 98.0921 206.176 106.437 206.176 117.917C206.176 129.397 214.674 137.741 226.386 137.741C238.097 137.741 246.595 129.397 246.595 117.917C246.595 106.437 238.097 98.0921 226.386 98.0921Z"
          fill="url(#paint35_linear_1886_6847)"
        />
        <path
          d="M226.171 157.564C203.201 157.564 185.881 140.42 185.881 117.699C185.881 94.9772 203.201 77.8333 226.171 77.8333C249.141 77.8333 266.461 94.9772 266.461 117.699C266.461 140.42 249.141 157.564 226.171 157.564ZM226.171 97.8741C214.459 97.8741 205.961 106.219 205.961 117.699C205.961 129.178 214.459 137.523 226.171 137.523C237.883 137.523 246.381 129.178 246.381 117.699C246.381 106.219 237.883 97.8741 226.171 97.8741Z"
          fill="url(#paint36_linear_1886_6847)"
        />
        <path
          d="M225.956 157.349C202.986 157.349 185.667 140.205 185.667 117.484C185.667 94.7621 202.986 77.6182 225.956 77.6182C248.927 77.6182 266.246 94.7621 266.246 117.484C266.246 140.205 248.927 157.349 225.956 157.349ZM225.956 97.659C214.245 97.659 205.747 106.004 205.747 117.484C205.747 128.963 214.245 137.308 225.956 137.308C237.668 137.308 246.166 128.963 246.166 117.484C246.166 106.004 237.668 97.659 225.956 97.659Z"
          fill="url(#paint37_linear_1886_6847)"
        />
        <path
          d="M225.739 157.133C202.769 157.133 185.449 139.989 185.449 117.267C185.449 94.5455 202.769 77.4016 225.739 77.4016C248.709 77.4016 266.029 94.5455 266.029 117.267C266.029 139.989 248.709 157.133 225.739 157.133ZM225.739 97.4425C214.027 97.4425 205.529 105.787 205.529 117.267C205.529 128.747 214.027 137.092 225.739 137.092C237.451 137.092 245.949 128.747 245.949 117.267C245.949 105.787 237.451 97.4425 225.739 97.4425Z"
          fill="url(#paint38_linear_1886_6847)"
        />
        <path
          d="M225.524 156.916C202.554 156.916 185.234 139.772 185.234 117.051C185.234 94.329 202.554 77.1851 225.524 77.1851C248.495 77.1851 265.814 94.329 265.814 117.051C265.814 139.772 248.495 156.916 225.524 156.916ZM225.524 97.226C213.813 97.226 205.315 105.571 205.315 117.051C205.315 128.53 213.813 136.875 225.524 136.875C237.236 136.875 245.734 128.53 245.734 117.051C245.734 105.571 237.236 97.226 225.524 97.226Z"
          fill="url(#paint39_linear_1886_6847)"
        />
        <path
          d="M225.307 156.7C202.336 156.7 185.017 139.556 185.017 116.834C185.017 94.1124 202.336 76.9685 225.307 76.9685C248.277 76.9685 265.597 94.1124 265.597 116.834C265.597 139.556 248.277 156.7 225.307 156.7ZM225.307 97.0093C213.595 97.0093 205.097 105.354 205.097 116.834C205.097 128.314 213.595 136.659 225.307 136.659C237.018 136.659 245.517 128.314 245.517 116.834C245.517 105.354 237.018 97.0093 225.307 97.0093Z"
          fill="url(#paint40_linear_1886_6847)"
        />
        <path
          d="M225.092 156.484C202.122 156.484 184.802 139.341 184.802 116.619C184.802 93.8973 202.122 76.7534 225.092 76.7534C248.063 76.7534 265.382 93.8973 265.382 116.619C265.382 139.341 248.063 156.484 225.092 156.484ZM225.092 96.7943C213.381 96.7943 204.883 105.139 204.883 116.619C204.883 128.099 213.381 136.444 225.092 136.444C236.804 136.444 245.302 128.099 245.302 116.619C245.302 105.139 236.804 96.7943 225.092 96.7943Z"
          fill="url(#paint41_linear_1886_6847)"
        />
        <path
          d="M224.878 156.268C201.907 156.268 184.588 139.124 184.588 116.402C184.588 93.6808 201.907 76.5369 224.878 76.5369C247.848 76.5369 265.167 93.6808 265.167 116.402C265.167 139.124 247.848 156.268 224.878 156.268ZM224.878 96.5777C213.166 96.5777 204.668 104.923 204.668 116.402C204.668 127.882 213.166 136.227 224.878 136.227C236.589 136.227 245.087 127.882 245.087 116.402C245.087 104.923 236.589 96.5777 224.878 96.5777Z"
          fill="url(#paint42_linear_1886_6847)"
        />
        <path
          d="M224.66 156.051C201.69 156.051 184.37 138.907 184.37 116.186C184.37 93.4642 201.69 76.3203 224.66 76.3203C247.63 76.3203 264.95 93.4642 264.95 116.186C264.95 138.907 247.63 156.051 224.66 156.051ZM224.66 96.3612C212.948 96.3612 204.45 104.706 204.45 116.186C204.45 127.666 212.948 136.011 224.66 136.011C236.372 136.011 244.87 127.666 244.87 116.186C244.87 104.706 236.372 96.3612 224.66 96.3612Z"
          fill="url(#paint43_linear_1886_6847)"
        />
        <path
          d="M224.445 155.835C201.475 155.835 184.156 138.691 184.156 115.97C184.156 93.2479 201.475 76.104 224.445 76.104C247.416 76.104 264.735 93.2479 264.735 115.97C264.735 138.691 247.416 155.835 224.445 155.835ZM224.445 96.1449C212.734 96.1449 204.236 104.49 204.236 115.97C204.236 127.449 212.734 135.794 224.445 135.794C236.157 135.794 244.655 127.449 244.655 115.97C244.655 104.49 236.157 96.1449 224.445 96.1449Z"
          fill="url(#paint44_linear_1886_6847)"
        />
        <path
          d="M224.231 155.62C201.26 155.62 183.941 138.476 183.941 115.754C183.941 93.0326 201.26 75.8887 224.231 75.8887C247.201 75.8887 264.521 93.0326 264.521 115.754C264.521 138.476 247.201 155.62 224.231 155.62ZM224.231 95.9295C212.519 95.9295 204.021 104.274 204.021 115.754C204.021 127.234 212.519 135.579 224.231 135.579C235.942 135.579 244.441 127.234 244.441 115.754C244.441 104.274 235.942 95.9295 224.231 95.9295Z"
          fill="url(#paint45_linear_1886_6847)"
        />
        <path
          d="M224.013 155.403C201.043 155.403 183.724 138.259 183.724 115.538C183.724 92.816 201.043 75.6721 224.013 75.6721C246.984 75.6721 264.303 92.816 264.303 115.538C264.303 138.259 246.984 155.403 224.013 155.403ZM224.013 95.713C212.302 95.713 203.804 104.058 203.804 115.538C203.804 127.017 212.302 135.362 224.013 135.362C235.725 135.362 244.223 127.017 244.223 115.538C244.223 104.058 235.725 95.713 224.013 95.713Z"
          fill="url(#paint46_linear_1886_6847)"
        />
        <path
          d="M223.799 155.187C200.828 155.187 183.509 138.043 183.509 115.321C183.509 92.5997 200.828 75.4558 223.799 75.4558C246.769 75.4558 264.088 92.5997 264.088 115.321C264.088 138.043 246.769 155.187 223.799 155.187ZM223.799 95.4966C212.087 95.4966 203.589 103.842 203.589 115.321C203.589 126.801 212.087 135.146 223.799 135.146C235.51 135.146 244.008 126.801 244.008 115.321C244.008 103.842 235.51 95.4966 223.799 95.4966Z"
          fill="url(#paint47_linear_1886_6847)"
        />
        <path
          d="M223.584 154.97C200.614 154.97 183.294 137.826 183.294 115.105C183.294 92.3832 200.614 75.2393 223.584 75.2393C246.554 75.2393 263.874 92.3832 263.874 115.105C263.874 137.826 246.554 154.97 223.584 154.97ZM223.584 95.2802C211.872 95.2802 203.374 103.625 203.374 115.105C203.374 126.585 211.872 134.929 223.584 134.929C235.296 134.929 243.794 126.585 243.794 115.105C243.794 103.625 235.296 95.2802 223.584 95.2802Z"
          fill="url(#paint48_linear_1886_6847)"
        />
        <path
          d="M223.367 154.754C200.396 154.754 183.077 137.61 183.077 114.888C183.077 92.1666 200.396 75.0227 223.367 75.0227C246.337 75.0227 263.656 92.1666 263.656 114.888C263.656 137.61 246.337 154.754 223.367 154.754ZM223.367 95.0636C211.655 95.0636 203.157 103.409 203.157 114.888C203.157 126.368 211.655 134.713 223.367 134.713C235.078 134.713 243.576 126.368 243.576 114.888C243.576 103.409 235.078 95.0636 223.367 95.0636Z"
          fill="url(#paint49_linear_1886_6847)"
        />
        <path
          d="M223.152 154.539C200.181 154.539 182.862 137.395 182.862 114.673C182.862 91.9515 200.181 74.8076 223.152 74.8076C246.122 74.8076 263.442 91.9515 263.442 114.673C263.442 137.395 246.122 154.539 223.152 154.539ZM223.152 94.8485C211.44 94.8485 202.942 103.193 202.942 114.673C202.942 126.153 211.44 134.498 223.152 134.498C234.864 134.498 243.362 126.153 243.362 114.673C243.362 103.193 234.864 94.8485 223.152 94.8485Z"
          fill="url(#paint50_linear_1886_6847)"
        />
        <path
          d="M222.934 154.322C199.964 154.322 182.645 137.178 182.645 114.457C182.645 91.735 199.964 74.5911 222.934 74.5911C245.905 74.5911 263.224 91.735 263.224 114.457C263.224 137.178 245.905 154.322 222.934 154.322ZM222.934 94.6319C211.223 94.6319 202.725 102.977 202.725 114.457C202.725 125.936 211.223 134.281 222.934 134.281C234.646 134.281 243.144 125.936 243.144 114.457C243.144 102.977 234.646 94.6319 222.934 94.6319Z"
          fill="url(#paint51_linear_1886_6847)"
        />
        <path
          d="M222.72 154.106C199.749 154.106 182.43 136.962 182.43 114.24C182.43 91.5184 199.749 74.3745 222.72 74.3745C245.69 74.3745 263.01 91.5184 263.01 114.24C263.01 136.962 245.69 154.106 222.72 154.106ZM222.72 94.4153C211.008 94.4153 202.51 102.76 202.51 114.24C202.51 125.72 211.008 134.065 222.72 134.065C234.431 134.065 242.929 125.72 242.929 114.24C242.929 102.76 234.431 94.4153 222.72 94.4153Z"
          fill="url(#paint52_linear_1886_6847)"
        />
        <path
          d="M222.505 153.889C199.535 153.889 182.215 136.745 182.215 114.023C182.215 91.3019 199.535 74.158 222.505 74.158C245.476 74.158 262.795 91.3019 262.795 114.023C262.795 136.745 245.476 153.889 222.505 153.889ZM222.505 94.1989C210.793 94.1989 202.296 102.544 202.296 114.023C202.296 125.503 210.793 133.848 222.505 133.848C234.217 133.848 242.715 125.503 242.715 114.023C242.715 102.544 234.217 94.1989 222.505 94.1989Z"
          fill="url(#paint53_linear_1886_6847)"
        />
        <path
          d="M222.288 153.674C199.318 153.674 181.998 136.53 181.998 113.808C181.998 91.0865 199.318 73.9426 222.288 73.9426C245.258 73.9426 262.578 91.0865 262.578 113.808C262.578 136.53 245.258 153.674 222.288 153.674ZM222.288 93.9835C210.576 93.9835 202.078 102.328 202.078 113.808C202.078 125.288 210.576 133.633 222.288 133.633C234 133.633 242.498 125.288 242.498 113.808C242.498 102.328 234 93.9835 222.288 93.9835Z"
          fill="url(#paint54_linear_1886_6847)"
        />
        <path
          d="M222.288 153.673C199.318 153.673 181.998 136.53 181.998 113.808C181.998 91.0863 199.318 73.9424 222.288 73.9424C245.258 73.9424 262.578 91.0863 262.578 113.808C262.578 136.53 245.258 153.673 222.288 153.673ZM222.288 93.9833C210.576 93.9833 202.078 102.328 202.078 113.808C202.078 125.288 210.576 133.633 222.288 133.633C234 133.633 242.498 125.288 242.498 113.808C242.498 102.328 234 93.9833 222.288 93.9833Z"
          fill="url(#paint55_linear_1886_6847)"
        />
        <path
          d="M222.29 152.137C200.182 152.137 183.531 135.663 183.531 113.807C183.531 91.9497 200.204 75.4761 222.29 75.4761C244.376 75.4761 261.048 91.9497 261.048 113.807C261.048 135.663 244.376 152.137 222.29 152.137ZM222.29 92.447C209.694 92.447 200.549 101.419 200.549 113.807C200.549 126.194 209.694 135.166 222.29 135.166C234.886 135.166 244.031 126.194 244.031 113.807C244.031 101.419 234.886 92.447 222.29 92.447Z"
          fill="url(#paint56_linear_1886_6847)"
        />
        <path
          d="M225.18 78.352C235.533 78.352 244.678 81.9624 251.494 88.059C244.505 80.2329 234.174 75.4551 222.29 75.4551C200.182 75.4551 183.531 91.9288 183.531 113.786C183.531 125.417 188.255 135.513 195.976 142.431C189.98 135.729 186.422 126.779 186.422 116.683C186.422 94.8258 203.094 78.352 225.18 78.352ZM239.394 100.144C242.327 103.776 244.031 108.467 244.031 113.807C244.031 126.173 234.886 135.167 222.29 135.167C216.704 135.167 211.808 133.394 208.076 130.367C211.959 135.145 217.998 138.064 225.18 138.064C237.776 138.064 246.921 129.092 246.921 116.704C246.921 109.808 244.074 103.971 239.394 100.144Z"
          fill="url(#paint57_linear_1886_6847)"
        />
        <rect
          x="110.522"
          y="1.9082"
          width="224.312"
          height="224.838"
          fill="url(#pattern1_1886_6847)"
        />
        <path
          d="M222.094 142.95C221.965 141.394 223.13 140.053 224.661 139.923C226.192 139.794 227.551 140.961 227.681 142.496C227.788 144.053 226.645 145.393 225.114 145.523C225.114 145.523 224.963 145.523 224.898 145.523C223.453 145.523 222.224 144.399 222.094 142.928V142.95ZM213.445 144.507C211.957 144.118 211.051 142.583 211.461 141.069C211.849 139.578 213.381 138.67 214.891 139.08C216.379 139.469 217.285 141.004 216.875 142.518C216.551 143.772 215.408 144.615 214.157 144.615C213.92 144.615 213.683 144.593 213.445 144.528V144.507ZM232.771 141.199C232.124 139.794 232.728 138.129 234.13 137.459C235.531 136.81 237.214 137.416 237.861 138.821C238.508 140.226 237.904 141.912 236.502 142.561C236.114 142.734 235.726 142.82 235.316 142.82C234.259 142.82 233.245 142.215 232.771 141.199ZM202.769 139.448C201.518 138.54 201.238 136.767 202.165 135.513C203.071 134.259 204.84 133.978 206.091 134.908C207.342 135.816 207.622 137.589 206.695 138.843C206.134 139.599 205.292 139.988 204.43 139.988C203.869 139.988 203.287 139.815 202.769 139.448ZM242.131 135.773C241.01 134.713 240.945 132.941 242.002 131.795C243.059 130.671 244.827 130.606 245.971 131.665C247.092 132.724 247.157 134.497 246.1 135.643C245.539 136.227 244.806 136.529 244.051 136.529C243.361 136.529 242.671 136.27 242.131 135.773ZM194.746 130.714C193.926 129.395 194.357 127.665 195.673 126.844C196.989 126.044 198.714 126.455 199.534 127.774C200.353 129.092 199.922 130.822 198.606 131.643C198.153 131.924 197.657 132.054 197.14 132.054C196.191 132.054 195.263 131.579 194.746 130.714ZM248.753 127.19C247.308 126.628 246.575 125.006 247.135 123.558C247.696 122.109 249.314 121.374 250.759 121.936C252.204 122.499 252.937 124.12 252.376 125.568C251.945 126.693 250.888 127.384 249.745 127.384C249.422 127.384 249.077 127.32 248.753 127.19ZM190.583 119.623C190.324 118.088 191.338 116.64 192.869 116.38C194.4 116.121 195.846 117.137 196.104 118.672C196.363 120.207 195.349 121.655 193.818 121.915C193.667 121.936 193.495 121.958 193.344 121.958C192.006 121.958 190.82 120.985 190.583 119.623ZM251.665 116.748C250.112 116.748 248.861 115.472 248.861 113.916V113.829V113.786C248.861 112.229 250.112 110.976 251.665 110.976C253.218 110.976 254.469 112.229 254.469 113.786V113.851V113.937C254.469 115.494 253.196 116.748 251.665 116.748ZM192.891 111.105C191.359 110.824 190.346 109.376 190.626 107.841C190.906 106.306 192.352 105.29 193.883 105.571C195.414 105.852 196.428 107.3 196.148 108.835C195.91 110.197 194.724 111.149 193.387 111.149C193.214 111.149 193.063 111.148 192.891 111.105ZM247.178 104.166C246.639 102.717 247.373 101.096 248.818 100.555C250.263 100.015 251.88 100.75 252.441 102.198C252.98 103.647 252.247 105.268 250.802 105.83C250.478 105.938 250.133 106.003 249.81 106.003C248.667 106.003 247.61 105.311 247.178 104.187V104.166ZM195.716 100.642C194.4 99.8201 193.991 98.0906 194.81 96.7719C195.63 95.4531 197.355 95.0423 198.671 95.8639C199.987 96.6854 200.396 98.4149 199.577 99.7337C199.038 100.598 198.132 101.074 197.183 101.074C196.687 101.074 196.169 100.944 195.716 100.642ZM242.088 95.9071C241.031 94.7613 241.096 92.9885 242.239 91.9292C243.382 90.8698 245.151 90.9347 246.208 92.0805C247.265 93.2263 247.2 94.9991 246.057 96.0584C245.518 96.5557 244.828 96.8151 244.159 96.8151C243.404 96.8151 242.649 96.5124 242.088 95.9071ZM202.251 91.994C201.346 90.7401 201.626 88.989 202.877 88.0593C204.128 87.1513 205.875 87.4324 206.802 88.6863C207.708 89.9402 207.428 91.6914 206.177 92.621C205.681 92.9885 205.098 93.1615 204.538 93.1615C203.675 93.1615 202.812 92.7507 202.273 91.994H202.251ZM234.259 90.178C232.857 89.5295 232.253 87.8432 232.9 86.4379C233.547 85.0327 235.229 84.4274 236.631 85.076C238.033 85.7462 238.637 87.4108 237.969 88.816C237.494 89.8321 236.48 90.4375 235.424 90.4375C235.035 90.4375 234.626 90.351 234.237 90.178H234.259ZM211.569 86.4812C211.181 84.9895 212.087 83.4545 213.575 83.0653C215.085 82.6762 216.594 83.5843 216.983 85.076C217.371 86.5893 216.465 88.1026 214.977 88.4917C214.739 88.5566 214.502 88.5782 214.265 88.5782C213.014 88.5782 211.871 87.7351 211.547 86.4596L211.569 86.4812ZM224.79 87.6919C223.237 87.5621 222.094 86.2002 222.224 84.6652C222.353 83.1086 223.712 81.9628 225.243 82.0925C226.796 82.2222 227.939 83.5842 227.81 85.1192C227.681 86.5893 226.473 87.6919 225.006 87.6919C225.006 87.6919 224.855 87.6919 224.769 87.6919H224.79Z"
          fill="#FFE0A9"
        />
        <path
          d="M223.108 142.864C223.022 141.869 223.755 141.004 224.747 140.94C225.739 140.853 226.58 141.61 226.666 142.583C226.753 143.555 226.02 144.42 225.027 144.507C225.027 144.507 224.941 144.507 224.876 144.507C223.949 144.507 223.172 143.793 223.108 142.864ZM213.704 143.512C212.755 143.253 212.194 142.28 212.431 141.329C212.69 140.377 213.661 139.815 214.61 140.053C215.559 140.313 216.12 141.286 215.882 142.237C215.667 143.037 214.955 143.577 214.157 143.577C214.006 143.577 213.855 143.577 213.704 143.512ZM233.698 140.767C233.288 139.88 233.676 138.799 234.561 138.389C235.466 137.978 236.523 138.367 236.933 139.253C237.343 140.161 236.955 141.221 236.07 141.631C235.833 141.74 235.574 141.804 235.315 141.804C234.647 141.804 234 141.415 233.698 140.767ZM203.373 138.605C202.575 138.021 202.402 136.897 202.984 136.097C203.567 135.297 204.688 135.124 205.486 135.708C206.284 136.291 206.457 137.416 205.875 138.216C205.53 138.691 204.99 138.951 204.429 138.951C204.063 138.951 203.696 138.843 203.373 138.605ZM242.843 135.016C242.131 134.346 242.088 133.2 242.757 132.487C243.425 131.773 244.547 131.73 245.28 132.4C245.992 133.07 246.035 134.194 245.366 134.929C245.021 135.319 244.547 135.492 244.051 135.492C243.619 135.492 243.188 135.34 242.843 135.016ZM195.608 130.173C195.09 129.33 195.349 128.228 196.19 127.709C197.031 127.19 198.131 127.449 198.649 128.292C199.167 129.136 198.908 130.238 198.067 130.757C197.786 130.93 197.463 131.016 197.139 131.016C196.535 131.016 195.953 130.714 195.608 130.173ZM249.119 126.239C248.192 125.893 247.739 124.855 248.084 123.925C248.429 122.996 249.464 122.542 250.392 122.888C251.319 123.234 251.772 124.271 251.427 125.201C251.147 125.914 250.478 126.347 249.766 126.347C249.551 126.347 249.335 126.303 249.141 126.239H249.119ZM191.596 119.429C191.424 118.456 192.071 117.526 193.041 117.353C194.012 117.18 194.939 117.829 195.112 118.802C195.284 119.774 194.637 120.704 193.667 120.877C193.667 120.877 193.473 120.899 193.365 120.899C192.524 120.899 191.769 120.293 191.618 119.407L191.596 119.429ZM251.664 115.732C250.672 115.732 249.874 114.932 249.896 113.937V113.872V113.808C249.896 112.813 250.694 112.013 251.686 112.013C252.678 112.013 253.476 112.813 253.476 113.808V113.894V113.959C253.476 114.953 252.678 115.732 251.686 115.732H251.664ZM193.063 110.089C192.092 109.916 191.445 108.987 191.618 108.014C191.79 107.041 192.718 106.392 193.688 106.565C194.659 106.738 195.306 107.668 195.133 108.641C194.982 109.505 194.228 110.111 193.365 110.111C193.365 110.111 193.149 110.111 193.063 110.089ZM248.127 103.798C247.782 102.868 248.257 101.852 249.162 101.506C250.09 101.16 251.104 101.615 251.449 102.544C251.794 103.474 251.341 104.49 250.413 104.836C250.198 104.922 250.004 104.944 249.788 104.944C249.055 104.944 248.386 104.511 248.106 103.776L248.127 103.798ZM196.255 99.7553C195.414 99.2364 195.155 98.1339 195.673 97.2907C196.19 96.4476 197.29 96.1881 198.132 96.707C198.973 97.2258 199.232 98.3284 198.714 99.1716C198.369 99.712 197.786 100.015 197.204 100.015C196.881 100.015 196.557 99.9283 196.277 99.7337L196.255 99.7553ZM242.843 95.2153C242.174 94.4803 242.217 93.356 242.951 92.6859C243.663 92.0157 244.806 92.0589 245.474 92.7723C246.143 93.4858 246.1 94.6315 245.388 95.3017C245.043 95.626 244.611 95.7774 244.18 95.7774C243.706 95.7774 243.231 95.5828 242.864 95.2153H242.843ZM203.092 91.3887C202.51 90.5888 202.704 89.4646 203.502 88.9025C204.3 88.3188 205.422 88.5134 206.004 89.2916C206.586 90.0916 206.392 91.2158 205.594 91.7995C205.271 92.0373 204.904 92.1454 204.559 92.1454C203.998 92.1454 203.459 91.886 203.114 91.4103L203.092 91.3887ZM234.69 89.2484C233.806 88.8377 233.417 87.7567 233.827 86.8703C234.237 85.9839 235.316 85.5948 236.2 86.0056C237.084 86.438 237.472 87.4973 237.062 88.3837C236.761 89.0323 236.113 89.4214 235.445 89.4214C235.186 89.4214 234.927 89.3565 234.69 89.2484ZM212.561 86.2218C212.324 85.2705 212.884 84.2977 213.855 84.0382C214.804 83.8004 215.774 84.3625 216.033 85.3354C216.271 86.2866 215.71 87.2594 214.761 87.5189C214.61 87.5621 214.459 87.5838 214.308 87.5838C213.51 87.5838 212.798 87.0433 212.582 86.2434L212.561 86.2218ZM224.876 86.6758C223.884 86.5893 223.172 85.7245 223.237 84.7516C223.323 83.7788 224.186 83.0437 225.157 83.1302C226.127 83.2167 226.861 84.0815 226.796 85.0543C226.71 85.984 225.933 86.6974 225.006 86.6974C225.006 86.6974 224.92 86.6974 224.855 86.6974L224.876 86.6758Z"
          fill="white"
        />
        <path
          d="M148.799 158.814V128.742H122.96V158.814H102.858V79.6016H122.96V108.701H148.799V79.6016H168.901V158.814H148.799Z"
          fill="url(#paint58_linear_1886_6847)"
        />
        <path
          d="M148.581 158.597V128.525H122.742V158.597H102.641V79.385H122.742V108.484H148.581V79.385H168.683V158.597H148.581Z"
          fill="url(#paint59_linear_1886_6847)"
        />
        <path
          d="M148.367 158.381V128.309H122.528V158.381H102.426V79.1685H122.528V108.268H148.367V79.1685H168.468V158.381H148.367Z"
          fill="url(#paint60_linear_1886_6847)"
        />
        <path
          d="M148.152 158.165V128.093H122.313V158.165H102.211V78.9309H122.313V108.052H148.152V78.9309H168.254V158.165H148.152Z"
          fill="url(#paint61_linear_1886_6847)"
        />
        <path
          d="M147.935 157.949V127.877H122.096V157.949H101.994V78.7368H122.096V107.836H147.935V78.7368H168.036V157.949H147.935Z"
          fill="url(#paint62_linear_1886_6847)"
        />
        <path
          d="M147.717 157.732V127.66H121.878V157.732H101.776V78.5203H121.878V107.62H147.717V78.5203H167.819V157.732H147.717Z"
          fill="url(#paint63_linear_1886_6847)"
        />
        <path
          d="M147.502 157.516V127.444H121.663V157.516H101.562V78.3037H121.663V107.403H147.502V78.3037H167.604V157.516H147.502Z"
          fill="url(#paint64_linear_1886_6847)"
        />
        <path
          d="M147.288 157.301V127.229H121.449V157.301H101.347V78.0886H121.449V107.188H147.288V78.0886H167.39V157.301H147.288Z"
          fill="url(#paint65_linear_1886_6847)"
        />
        <path
          d="M147.07 157.084V127.012H121.231V157.084H101.13V77.8499H121.231V106.971H147.07V77.8499H167.172V157.084H147.07Z"
          fill="url(#paint66_linear_1886_6847)"
        />
        <path
          d="M146.856 156.868V126.796H121.017V156.868H100.915V77.6555H121.017V106.755H146.856V77.6555H166.957V156.868H146.856Z"
          fill="url(#paint67_linear_1886_6847)"
        />
        <path
          d="M146.641 156.651V126.579H120.802V156.651H100.7V77.439H120.802V106.538H146.641V77.439H166.743V156.651H146.641Z"
          fill="url(#paint68_linear_1886_6847)"
        />
        <path
          d="M146.424 156.435V126.363H120.585V156.435H100.483V77.2227H120.585V106.322H146.424V77.2227H166.525V156.435H146.424Z"
          fill="url(#paint69_linear_1886_6847)"
        />
        <path
          d="M146.209 156.219V126.147H120.37V156.219H100.268V77.0073H120.37V106.107H146.209V77.0073H166.311V156.219H146.209Z"
          fill="url(#paint70_linear_1886_6847)"
        />
        <path
          d="M145.992 156.002V125.93H120.153V156.002H100.051V76.7686H120.153V105.889H145.992V76.7686H166.093V156.002H145.992Z"
          fill="url(#paint71_linear_1886_6847)"
        />
        <path
          d="M145.78 155.787V125.715H119.941V155.787H99.8389V76.5745H119.941V105.674H145.78V76.5745H165.881V155.787H145.78Z"
          fill="url(#paint72_linear_1886_6847)"
        />
        <path
          d="M145.562 155.57V125.498H119.723V155.57H99.6214V76.3579H119.723V105.457H145.562V76.3579H165.664V155.57H145.562Z"
          fill="url(#paint73_linear_1886_6847)"
        />
        <path
          d="M145.345 155.355V125.283H119.506V155.355H99.4039V76.1428H119.506V105.242H145.345V76.1428H165.446V155.355H145.345Z"
          fill="url(#paint74_linear_1886_6847)"
        />
        <path
          d="M145.13 155.138V125.066H119.291V155.138H99.1893V75.9263H119.291V105.025H145.13V75.9263H165.232V155.138H145.13Z"
          fill="url(#paint75_linear_1886_6847)"
        />
        <path
          d="M144.915 154.923V124.85H119.076V154.923H98.9746V75.6887H119.076V104.81H144.915V75.6887H165.017V154.923H144.915Z"
          fill="url(#paint76_linear_1886_6847)"
        />
        <path
          d="M144.698 154.705V124.633H118.859V154.705H98.7572V75.4932H118.859V104.592H144.698V75.4932H164.8V154.705H144.698Z"
          fill="url(#paint77_linear_1886_6847)"
        />
        <path
          d="M144.483 154.49V124.418H118.644V154.49H98.5425V75.2781H118.644V104.377H144.483V75.2781H164.585V154.49H144.483Z"
          fill="url(#paint78_linear_1886_6847)"
        />
        <path
          d="M144.269 154.274V124.202H118.43V154.274H98.3279V75.0615H118.43V104.161H144.269V75.0615H164.37V154.274H144.269Z"
          fill="url(#paint79_linear_1886_6847)"
        />
        <path
          d="M144.054 154.057V123.985H118.215V154.057H98.1132V74.845H118.215V103.944H144.054V74.845H164.156V154.057H144.054Z"
          fill="url(#paint80_linear_1886_6847)"
        />
        <path
          d="M143.837 153.841V123.769H117.998V153.841H97.8958V74.6074H117.998V103.728H143.837V74.6074H163.938V153.841H143.837Z"
          fill="url(#paint81_linear_1886_6847)"
        />
        <path
          d="M143.619 153.626V123.553H117.78V153.626H97.6783V74.4133H117.78V103.513H143.619V74.4133H163.721V153.626H143.619Z"
          fill="url(#paint82_linear_1886_6847)"
        />
        <path
          d="M143.407 153.409V123.337H117.568V153.409H97.4664V74.1968H117.568V103.296H143.407V74.1968H163.509V153.409H143.407Z"
          fill="url(#paint83_linear_1886_6847)"
        />
        <path
          d="M143.407 153.409V123.337H117.568V153.409H97.4659V74.1973H117.568V103.297H143.407V74.1973H163.508V153.409H143.407Z"
          fill="url(#paint84_linear_1886_6847)"
        />
        <path
          d="M144.934 151.874V121.802H116.033V151.874H98.9937V75.71H116.033V104.831H144.934V75.71H161.973V151.874H144.934Z"
          fill="url(#paint85_linear_1886_6847)"
        />
        <path
          d="M98.9937 151.874H101.884V78.6285H116.033V75.7316H98.9937V151.874ZM144.934 75.71V104.809H118.923V107.706H147.825V78.6069H161.973V75.71H144.934ZM144.934 151.874H147.825V124.699H144.934V151.874Z"
          fill="url(#paint86_linear_1886_6847)"
        />
        <rect
          x="23.9789"
          width="211.371"
          height="227"
          fill="url(#pattern2_1886_6847)"
        />
        <path
          d="M104.711 137.042C104.711 135.486 105.962 134.232 107.515 134.232C109.068 134.232 110.319 135.486 110.319 137.042C110.319 138.599 109.068 139.853 107.515 139.853C105.962 139.853 104.711 138.599 104.711 137.042ZM104.711 126.319C104.711 124.763 105.962 123.509 107.515 123.509C109.068 123.509 110.319 124.763 110.319 126.319C110.319 127.876 109.068 129.13 107.515 129.13C105.962 129.13 104.711 127.876 104.711 126.319ZM104.711 115.575C104.711 114.018 105.962 112.764 107.515 112.764C109.068 112.764 110.319 114.018 110.319 115.575C110.319 117.131 109.068 118.385 107.515 118.385C105.962 118.385 104.711 117.131 104.711 115.575ZM104.711 104.852C104.711 103.295 105.962 102.041 107.515 102.041C109.068 102.041 110.319 103.295 110.319 104.852C110.319 106.408 109.068 107.662 107.515 107.662C105.962 107.662 104.711 106.408 104.711 104.852ZM104.711 94.107C104.711 92.5505 105.962 91.2965 107.515 91.2965C109.068 91.2965 110.319 92.5505 110.319 94.107C110.319 95.6636 109.068 96.9175 107.515 96.9175C105.962 96.9175 104.711 95.6636 104.711 94.107ZM104.711 83.3839C104.711 81.8274 105.962 80.5735 107.515 80.5735C109.068 80.5735 110.319 81.8274 110.319 83.3839C110.319 84.9405 109.068 86.1945 107.515 86.1945C105.962 86.1945 104.711 84.9405 104.711 83.3839Z"
          fill="#FFE0A9"
        />
        <path
          d="M150.674 137.042C150.674 135.486 151.925 134.232 153.478 134.232C155.03 134.232 156.281 135.486 156.281 137.042C156.281 138.599 155.03 139.853 153.478 139.853C151.925 139.853 150.674 138.599 150.674 137.042ZM150.674 126.319C150.674 124.763 151.925 123.509 153.478 123.509C155.03 123.509 156.281 124.763 156.281 126.319C156.281 127.876 155.03 129.13 153.478 129.13C151.925 129.13 150.674 127.876 150.674 126.319ZM150.674 115.575C150.674 114.018 151.925 112.764 153.478 112.764C155.03 112.764 156.281 114.018 156.281 115.575C156.281 117.131 155.03 118.385 153.478 118.385C151.925 118.385 150.674 117.131 150.674 115.575ZM150.674 104.852C150.674 103.295 151.925 102.041 153.478 102.041C155.03 102.041 156.281 103.295 156.281 104.852C156.281 106.408 155.03 107.662 153.478 107.662C151.925 107.662 150.674 106.408 150.674 104.852ZM150.674 94.107C150.674 92.5505 151.925 91.2965 153.478 91.2965C155.03 91.2965 156.281 92.5505 156.281 94.107C156.281 95.6636 155.03 96.9175 153.478 96.9175C151.925 96.9175 150.674 95.6636 150.674 94.107ZM150.674 83.3839C150.674 81.8274 151.925 80.5735 153.478 80.5735C155.03 80.5735 156.281 81.8274 156.281 83.3839C156.281 84.9405 155.03 86.1945 153.478 86.1945C151.925 86.1945 150.674 84.9405 150.674 83.3839Z"
          fill="#FFE0A9"
        />
        <path
          d="M138.122 113.371C138.122 111.814 139.373 110.56 140.926 110.56C142.479 110.56 143.73 111.814 143.73 113.371C143.73 114.927 142.479 116.181 140.926 116.181C139.373 116.181 138.122 114.927 138.122 113.371ZM127.402 113.371C127.402 111.814 128.653 110.56 130.206 110.56C131.759 110.56 133.01 111.814 133.01 113.371C133.01 114.927 131.759 116.181 130.206 116.181C128.653 116.181 127.402 114.927 127.402 113.371ZM116.704 113.371C116.704 111.814 117.955 110.56 119.508 110.56C121.061 110.56 122.312 111.814 122.312 113.371C122.312 114.927 121.061 116.181 119.508 116.181C117.955 116.181 116.704 114.927 116.704 113.371Z"
          fill="#FFE0A9"
        />
        <path
          d="M105.725 137.044C105.725 136.049 106.524 135.25 107.516 135.25C108.508 135.25 109.306 136.049 109.306 137.044C109.306 138.038 108.508 138.838 107.516 138.838C106.524 138.838 105.725 138.038 105.725 137.044ZM105.725 126.321C105.725 125.326 106.524 124.526 107.516 124.526C108.508 124.526 109.306 125.326 109.306 126.321C109.306 127.315 108.508 128.115 107.516 128.115C106.524 128.115 105.725 127.315 105.725 126.321ZM105.725 115.576C105.725 114.582 106.524 113.782 107.516 113.782C108.508 113.782 109.306 114.582 109.306 115.576C109.306 116.571 108.508 117.371 107.516 117.371C106.524 117.371 105.725 116.571 105.725 115.576ZM105.725 104.853C105.725 103.859 106.524 103.059 107.516 103.059C108.508 103.059 109.306 103.859 109.306 104.853C109.306 105.848 108.508 106.648 107.516 106.648C106.524 106.648 105.725 105.848 105.725 104.853ZM105.725 94.1085C105.725 93.114 106.524 92.3141 107.516 92.3141C108.508 92.3141 109.306 93.114 109.306 94.1085C109.306 95.103 108.508 95.9029 107.516 95.9029C106.524 95.9029 105.725 95.103 105.725 94.1085ZM105.725 83.3854C105.725 82.3909 106.524 81.5911 107.516 81.5911C108.508 81.5911 109.306 82.3909 109.306 83.3854C109.306 84.3799 108.508 85.1798 107.516 85.1798C106.524 85.1798 105.725 84.3799 105.725 83.3854Z"
          fill="white"
        />
        <path
          d="M151.685 137.044C151.685 136.049 152.483 135.25 153.475 135.25C154.467 135.25 155.265 136.049 155.265 137.044C155.265 138.038 154.467 138.838 153.475 138.838C152.483 138.838 151.685 138.038 151.685 137.044ZM151.685 126.321C151.685 125.326 152.483 124.526 153.475 124.526C154.467 124.526 155.265 125.326 155.265 126.321C155.265 127.315 154.467 128.115 153.475 128.115C152.483 128.115 151.685 127.315 151.685 126.321ZM151.685 115.576C151.685 114.582 152.483 113.782 153.475 113.782C154.467 113.782 155.265 114.582 155.265 115.576C155.265 116.571 154.467 117.371 153.475 117.371C152.483 117.371 151.685 116.571 151.685 115.576ZM151.685 104.853C151.685 103.859 152.483 103.059 153.475 103.059C154.467 103.059 155.265 103.859 155.265 104.853C155.265 105.848 154.467 106.648 153.475 106.648C152.483 106.648 151.685 105.848 151.685 104.853ZM151.685 94.1085C151.685 93.114 152.483 92.3141 153.475 92.3141C154.467 92.3141 155.265 93.114 155.265 94.1085C155.265 95.103 154.467 95.9029 153.475 95.9029C152.483 95.9029 151.685 95.103 151.685 94.1085ZM151.685 83.3854C151.685 82.3909 152.483 81.5911 153.475 81.5911C154.467 81.5911 155.265 82.3909 155.265 83.3854C155.265 84.3799 154.467 85.1798 153.475 85.1798C152.483 85.1798 151.685 84.3799 151.685 83.3854Z"
          fill="white"
        />
        <path
          d="M139.133 113.371C139.133 112.376 139.931 111.576 140.923 111.576C141.916 111.576 142.714 112.376 142.714 113.371C142.714 114.365 141.916 115.165 140.923 115.165C139.931 115.165 139.133 114.365 139.133 113.371ZM128.414 113.371C128.414 112.376 129.212 111.576 130.204 111.576C131.196 111.576 131.994 112.376 131.994 113.371C131.994 114.365 131.196 115.165 130.204 115.165C129.212 115.165 128.414 114.365 128.414 113.371ZM117.716 113.371C117.716 112.376 118.514 111.576 119.506 111.576C120.498 111.576 121.296 112.376 121.296 113.371C121.296 114.365 120.498 115.165 119.506 115.165C118.514 115.165 117.716 114.365 117.716 113.371Z"
          fill="white"
        />
        <path
          d="M54.5972 158.424C43.209 158.424 32.0366 153.711 26.1484 146.404L20.7563 139.724L35.2934 126.19L41.5051 133.541C43.4678 135.876 48.709 138.362 54.5109 138.362C60.3128 138.362 62.5559 136.957 63.3108 136.351C64.0873 135.746 64.3892 135.076 64.3892 134.016C64.3892 132.417 64.3892 131.271 52.7854 128.439C47.1992 127.077 41.4188 125.671 36.415 122.537C29.4699 118.191 25.8033 111.511 25.8033 103.166C25.8033 90.9729 34.9052 78.6716 55.2658 78.6716C63.6775 78.6716 72.3479 81.4605 78.4302 86.1302L85.3537 91.4485L74.095 107.857L66.4598 102.258C63.5049 100.074 59.2344 98.7341 55.3305 98.7341C51.7933 98.7341 45.8619 99.3178 45.8619 103.252C45.8619 105.133 46.3796 106.236 57.6599 109.025C63.203 110.387 68.9186 111.792 73.8793 114.884C80.7812 119.186 84.4263 125.801 84.4263 134.016C84.4263 141.021 81.4714 147.334 76.1224 151.744C70.7519 156.176 63.5049 158.424 54.5325 158.424H54.5972Z"
          fill="url(#paint87_linear_1886_6847)"
        />
        <path
          d="M54.3825 158.209C42.9944 158.209 31.8219 153.496 25.9337 146.189L20.5416 139.509L35.0788 125.975L41.2904 133.326C43.2532 135.661 48.4943 138.147 54.2962 138.147C60.0981 138.147 62.3412 136.742 63.0961 136.136C63.8726 135.531 64.1745 134.861 64.1745 133.801C64.1745 132.202 64.1746 131.056 52.5708 128.224C46.9845 126.862 41.2042 125.456 36.2003 122.322C29.2553 117.976 25.5886 111.296 25.5886 102.951C25.5886 90.7578 34.6905 78.4565 55.0511 78.4565C63.4628 78.4565 72.1333 81.2454 78.2156 85.9151L85.1391 91.2334L73.8803 107.642L66.2451 102.043C63.2903 99.8594 59.0197 98.519 55.1158 98.519C51.5786 98.519 45.6473 99.1028 45.6473 103.037C45.6473 104.918 46.1649 106.021 57.4452 108.81C62.9883 110.172 68.7039 111.577 73.6647 114.668C80.5666 118.971 84.2116 125.586 84.2116 133.801C84.2116 140.806 81.2568 147.119 75.9078 151.529C70.5372 155.961 63.2903 158.209 54.3178 158.209H54.3825Z"
          fill="url(#paint88_linear_1886_6847)"
        />
        <path
          d="M54.1678 157.993C42.7797 157.993 31.6073 153.28 25.7191 145.972L20.327 139.292L34.8641 125.759L41.0758 133.109C43.0385 135.444 48.2796 137.93 54.0815 137.93C59.8835 137.93 62.1266 136.525 62.8815 135.92C63.6579 135.314 63.9599 134.644 63.9599 133.585C63.9599 131.985 63.9599 130.839 52.3561 128.007C46.7698 126.645 40.9895 125.24 35.9856 122.105C29.0406 117.76 25.374 111.079 25.374 102.734C25.374 90.5412 34.4759 78.24 54.8365 78.24C63.2481 78.24 71.9186 81.0288 78.0009 85.6985L84.9244 91.0168L73.6657 107.426L66.0304 101.826C63.0756 99.6428 58.805 98.3025 54.9012 98.3025C51.3639 98.3025 45.4326 98.8862 45.4326 102.821C45.4326 104.702 45.9503 105.804 57.2305 108.593C62.7736 109.955 68.4892 111.36 73.45 114.452C80.3519 118.754 83.9969 125.369 83.9969 133.585C83.9969 140.589 81.0421 146.902 75.6931 151.312C70.3226 155.744 63.0756 157.993 54.1031 157.993H54.1678Z"
          fill="url(#paint89_linear_1886_6847)"
        />
        <path
          d="M53.9504 157.776C42.5622 157.776 31.3898 153.063 25.5016 145.756L20.1095 139.076L34.6466 125.542L40.8583 132.893C42.821 135.227 48.0622 137.714 53.8641 137.714C59.666 137.714 61.9091 136.308 62.664 135.703C63.4405 135.098 63.7424 134.428 63.7424 133.368C63.7424 131.768 63.7424 130.623 52.1386 127.79C46.5524 126.428 40.772 125.023 35.7682 121.889C28.8231 117.543 25.1565 110.863 25.1565 102.518C25.1565 90.3246 34.2584 78.0234 54.619 78.0234C63.0307 78.0234 71.7012 80.8123 77.7835 85.482L84.7069 90.8003L73.4482 107.209L65.813 101.61C62.8581 99.4263 58.5876 98.0859 54.6837 98.0859C51.1465 98.0859 45.2151 98.6696 45.2151 102.604C45.2151 104.485 45.7328 105.588 57.0131 108.377C62.5562 109.739 68.2718 111.144 73.2325 114.235C80.1344 118.538 83.7795 125.153 83.7795 133.368C83.7795 140.373 80.8246 146.686 75.4757 151.096C70.1051 155.528 62.8581 157.776 53.8857 157.776H53.9504Z"
          fill="url(#paint90_linear_1886_6847)"
        />
        <path
          d="M53.7357 157.56C42.3476 157.56 31.1751 152.847 25.2869 145.539L19.8948 138.859L34.432 125.326L40.6437 132.676C42.6064 135.011 47.8475 137.497 53.6494 137.497C59.4514 137.497 61.6945 136.092 62.4494 135.486C63.2258 134.881 63.5278 134.211 63.5278 133.152C63.5278 131.552 63.5278 130.406 51.924 127.574C46.3377 126.212 40.5574 124.807 35.5535 121.672C28.6085 117.327 24.9419 110.646 24.9419 102.301C24.9419 90.1081 34.0437 77.8069 54.4043 77.8069C62.816 77.8069 71.4865 80.5958 77.5688 85.2655L84.4923 90.5837L73.2336 106.993L65.5983 101.393C62.6435 99.2098 58.3729 97.8694 54.469 97.8694C50.9318 97.8694 45.0005 98.4531 45.0005 102.388C45.0005 104.269 45.5181 105.371 56.7984 108.16C62.3415 109.522 68.0571 110.927 73.0179 114.019C79.9198 118.321 83.5648 124.936 83.5648 133.152C83.5648 140.156 80.61 146.469 75.261 150.879C69.8904 155.311 62.6435 157.56 53.671 157.56H53.7357Z"
          fill="url(#paint91_linear_1886_6847)"
        />
        <path
          d="M53.521 157.344C42.1329 157.344 30.9605 152.632 25.0723 145.324L19.6802 138.644L34.2173 125.11L40.429 132.461C42.3917 134.796 47.6328 137.282 53.4348 137.282C59.2367 137.282 61.4798 135.877 62.2347 135.271C63.0111 134.666 63.3131 133.996 63.3131 132.937C63.3131 131.337 63.3131 130.191 51.7093 127.359C46.1231 125.997 40.3427 124.592 35.3388 121.457C28.3938 117.111 24.7272 110.431 24.7272 102.086C24.7272 89.8931 33.8291 77.5918 54.1897 77.5918C62.6013 77.5918 71.2718 80.3807 77.3541 85.0504L84.2776 90.3687L73.0189 106.778L65.3837 101.178C62.4288 98.9947 58.1583 97.6543 54.2544 97.6543C50.7171 97.6543 44.7858 98.238 44.7858 102.173C44.7858 104.054 45.3035 105.156 56.5838 107.945C62.1268 109.307 67.8425 110.712 72.8032 113.804C79.7051 118.106 83.3502 124.721 83.3502 132.937C83.3502 139.941 80.3953 146.254 75.0463 150.664C69.6758 155.096 62.4288 157.344 53.4563 157.344H53.521Z"
          fill="url(#paint92_linear_1886_6847)"
        />
        <path
          d="M53.3036 157.128C41.9154 157.128 30.743 152.415 24.8548 145.108L19.4627 138.427L33.9998 124.894L40.2115 132.244C42.1743 134.579 47.4154 137.065 53.2173 137.065C59.0192 137.065 61.2623 135.66 62.0172 135.055C62.7937 134.45 63.0956 133.779 63.0956 132.72C63.0956 131.12 63.0957 129.974 51.4918 127.142C45.9056 125.78 40.1253 124.375 35.1214 121.24C28.1764 116.895 24.5097 110.215 24.5097 101.87C24.5097 89.6765 33.6116 77.3752 53.9722 77.3752C62.3839 77.3752 71.0544 80.1641 77.1367 84.8338L84.0602 90.1521L72.8014 106.561L65.1662 100.962C62.2113 98.7781 57.9408 97.4377 54.0369 97.4377C50.4997 97.4377 44.5684 98.0215 44.5684 101.956C44.5684 103.837 45.086 104.94 56.3663 107.728C61.9094 109.09 67.625 110.496 72.5858 113.587C79.4877 117.889 83.1327 124.505 83.1327 132.72C83.1327 139.725 80.1778 146.037 74.8289 150.448C69.4583 154.88 62.2113 157.128 53.2389 157.128H53.3036Z"
          fill="url(#paint93_linear_1886_6847)"
        />
        <path
          d="M53.0861 156.911C41.698 156.911 30.5256 152.198 24.6374 144.891L19.2453 138.211L33.7824 124.677L39.9941 132.028C41.9568 134.363 47.198 136.849 52.9999 136.849C58.8018 136.849 61.0449 135.444 61.7998 134.838C62.5763 134.233 62.8782 133.563 62.8782 132.503C62.8782 130.904 62.8782 129.758 51.2744 126.926C45.6882 125.564 39.9078 124.158 34.904 121.024C27.9589 116.678 24.2923 109.998 24.2923 101.653C24.2923 89.4599 33.3942 77.1587 53.7548 77.1587C62.1665 77.1587 70.837 79.9475 76.9193 84.6172L83.8427 89.9355L72.584 106.344L64.9488 100.745C61.9939 98.5615 57.7234 97.2212 53.8195 97.2212C50.2823 97.2212 44.351 97.8049 44.351 101.74C44.351 103.62 44.8686 104.723 56.1489 107.512C61.692 108.874 67.4076 110.279 72.3683 113.371C79.2702 117.673 82.9153 124.288 82.9153 132.503C82.9153 139.508 79.9604 145.821 74.6115 150.231C69.2409 154.663 61.9939 156.911 53.0214 156.911H53.0861Z"
          fill="url(#paint94_linear_1886_6847)"
        />
        <path
          d="M52.8743 156.696C41.4861 156.696 30.3137 151.983 24.4255 144.676L19.0334 137.996L33.5705 124.462L39.7822 131.813C41.7449 134.148 46.9861 136.634 52.788 136.634C58.5899 136.634 60.833 135.229 61.5879 134.623C62.3644 134.018 62.6663 133.348 62.6663 132.288C62.6663 130.689 62.6663 129.543 51.0625 126.711C45.4763 125.349 39.6959 123.943 34.6921 120.809C27.747 116.463 24.0804 109.783 24.0804 101.438C24.0804 89.2448 33.1823 76.9436 53.5429 76.9436C61.9546 76.9436 70.6251 79.7324 76.7074 84.4021L83.6308 89.7205L72.3721 106.129L64.7369 100.53C61.782 98.3465 57.5115 97.0061 53.6076 97.0061C50.0704 97.0061 44.139 97.5898 44.139 101.524C44.139 103.405 44.6567 104.508 55.937 107.297C61.4801 108.659 67.1957 110.064 72.1564 113.156C79.0583 117.458 82.7034 124.073 82.7034 132.288C82.7034 139.293 79.7485 145.606 74.3995 150.016C69.029 154.448 61.782 156.696 52.8096 156.696H52.8743Z"
          fill="url(#paint95_linear_1886_6847)"
        />
        <path
          d="M52.6568 156.479C41.2687 156.479 30.0963 151.766 24.2081 144.458L18.816 137.778L33.3531 124.245L39.5648 131.595C41.5276 133.93 46.7687 136.416 52.5706 136.416C58.3725 136.416 60.6156 135.011 61.3705 134.405C62.147 133.8 62.4489 133.13 62.4489 132.071C62.4489 130.471 62.4489 129.325 50.8451 126.493C45.2589 125.131 39.4786 123.726 34.4747 120.591C27.5296 116.245 23.863 109.565 23.863 101.22C23.863 89.027 32.9649 76.7258 53.3255 76.7258C61.7371 76.7258 70.4077 79.5147 76.49 84.1844L83.4134 89.5027L72.1547 105.912L64.5195 100.312C61.5646 98.1287 57.294 96.7883 53.3902 96.7883C49.8529 96.7883 43.9216 97.372 43.9216 101.307C43.9216 103.188 44.4393 104.29 55.7196 107.079C61.2626 108.441 66.9783 109.846 71.939 112.938C78.8409 117.24 82.486 123.855 82.486 132.071C82.486 139.075 79.5311 145.388 74.1821 149.798C68.8116 154.23 61.5646 156.479 52.5921 156.479H52.6568Z"
          fill="url(#paint96_linear_1886_6847)"
        />
        <path
          d="M52.4422 156.263C41.0541 156.263 29.8816 151.55 23.9934 144.243L18.6013 137.563L33.1384 124.029L39.3501 131.38C41.3129 133.715 46.554 136.201 52.3559 136.201C58.1578 136.201 60.4009 134.795 61.1558 134.19C61.9323 133.585 62.2342 132.915 62.2342 131.855C62.2342 130.255 62.2342 129.11 50.6304 126.278C45.0442 124.916 39.2639 123.51 34.26 120.376C27.315 116.03 23.6483 109.35 23.6483 101.005C23.6483 88.8118 32.7502 76.5105 53.1108 76.5105C61.5225 76.5105 70.193 79.2994 76.2753 83.9691L83.1988 89.2874L71.94 105.696L64.3048 100.097C61.35 97.9134 57.0794 96.573 53.1755 96.573C49.6383 96.573 43.707 97.1567 43.707 101.091C43.707 102.972 44.2246 104.075 55.5049 106.864C61.048 108.226 66.7636 109.631 71.7243 112.722C78.6262 117.025 82.2713 123.64 82.2713 131.855C82.2713 138.86 79.3164 145.173 73.9675 149.583C68.5969 154.015 61.35 156.263 52.3775 156.263H52.4422Z"
          fill="url(#paint97_linear_1886_6847)"
        />
        <path
          d="M52.2247 156.047C40.8366 156.047 29.6641 151.334 23.776 144.026L18.3839 137.346L32.921 123.813L39.1327 131.163C41.0954 133.498 46.3366 135.984 52.1385 135.984C57.9404 135.984 60.1835 134.579 60.9384 133.974C61.7148 133.368 62.0168 132.698 62.0168 131.639C62.0168 130.039 62.0168 128.893 50.413 126.061C44.8268 124.699 39.0464 123.294 34.0426 120.159C27.0975 115.814 23.4309 109.133 23.4309 100.788C23.4309 88.5952 32.5327 76.2939 52.8933 76.2939C61.305 76.2939 69.9755 79.0828 76.0578 83.7525L82.9813 89.0708L71.7226 105.48L64.0874 99.8803C61.1325 97.6968 56.8619 96.3564 52.958 96.3564C49.4208 96.3564 43.4895 96.9402 43.4895 100.875C43.4895 102.756 44.0071 103.858 55.2874 106.647C60.8305 108.009 66.5462 109.414 71.5069 112.506C78.4088 116.808 82.0539 123.423 82.0539 131.639C82.0539 138.643 79.099 144.956 73.75 149.366C68.3795 153.798 61.1325 156.047 52.16 156.047H52.2247Z"
          fill="url(#paint98_linear_1886_6847)"
        />
        <path
          d="M52.01 155.83C40.6219 155.83 29.4495 151.117 23.5613 143.81L18.1692 137.13L32.7063 123.596L38.918 130.947C40.8807 133.282 46.1219 135.768 51.9238 135.768C57.7257 135.768 59.9688 134.363 60.7237 133.757C61.5002 133.152 61.8021 132.482 61.8021 131.422C61.8021 129.823 61.8021 128.677 50.1983 125.845C44.6121 124.483 38.8317 123.077 33.8279 119.943C26.8828 115.597 23.2162 108.917 23.2162 100.572C23.2162 88.3788 32.3181 76.0776 52.6787 76.0776C61.0904 76.0776 69.7609 78.8665 75.8431 83.5362L82.7666 88.8544L71.5079 105.263L63.8727 99.664C60.9178 97.4804 56.6473 96.1401 52.7434 96.1401C49.2062 96.1401 43.2748 96.7238 43.2748 100.658C43.2748 102.539 43.7925 103.642 55.0728 106.431C60.6159 107.793 66.3315 109.198 71.2922 112.29C78.1941 116.592 81.8392 123.207 81.8392 131.422C81.8392 138.427 78.8843 144.74 73.5353 149.15C68.1648 153.582 60.9178 155.83 51.9453 155.83H52.01Z"
          fill="url(#paint99_linear_1886_6847)"
        />
        <path
          d="M51.7954 155.614C40.4073 155.614 29.2348 150.901 23.3466 143.594L17.9545 136.913L32.4917 123.38L38.7033 130.73C40.6661 133.065 45.9072 135.551 51.7091 135.551C57.511 135.551 59.7541 134.146 60.509 133.541C61.2855 132.935 61.5875 132.265 61.5875 131.206C61.5875 129.606 61.5875 128.46 49.9837 125.628C44.3974 124.266 38.6171 122.861 33.6132 119.726C26.6682 115.381 23.0015 108.7 23.0015 100.355C23.0015 88.1623 32.1034 75.8611 52.464 75.8611C60.8757 75.8611 69.5462 78.6499 75.6285 83.3196L82.552 88.6379L71.2932 105.047L63.658 99.4475C60.7032 97.2639 56.4326 95.9236 52.5287 95.9236C48.9915 95.9236 43.0602 96.5073 43.0602 100.442C43.0602 102.323 43.5778 103.425 54.8581 106.214C60.4012 107.576 66.1168 108.981 71.0776 112.073C77.9795 116.375 81.6245 122.991 81.6245 131.206C81.6245 138.21 78.6697 144.523 73.3207 148.933C67.9501 153.365 60.7032 155.614 51.7307 155.614H51.7954Z"
          fill="url(#paint100_linear_1886_6847)"
        />
        <path
          d="M51.5779 155.399C40.1898 155.399 29.0173 150.686 23.1292 143.378L17.7371 136.698L32.2742 123.165L38.4859 130.515C40.4486 132.85 45.6898 135.336 51.4917 135.336C57.2936 135.336 59.5367 133.931 60.2916 133.326C61.0681 132.72 61.37 132.05 61.37 130.991C61.37 129.391 61.37 128.245 49.7662 125.413C44.18 124.051 38.3996 122.646 33.3958 119.511C26.4507 115.166 22.7841 108.485 22.7841 100.14C22.7841 87.9472 31.886 75.646 52.2465 75.646C60.6582 75.646 69.3288 78.4349 75.411 83.1046L82.3345 88.4229L71.0758 104.832L63.4406 99.2324C60.4857 97.0489 56.2151 95.7085 52.3112 95.7085C48.774 95.7085 42.8427 96.2922 42.8427 100.227C42.8427 102.108 43.3604 103.21 54.6406 105.999C60.1837 107.361 65.8994 108.766 70.8601 111.858C77.762 116.16 81.4071 122.776 81.4071 130.991C81.4071 137.995 78.4522 144.308 73.1032 148.718C67.7327 153.15 60.4857 155.399 51.5132 155.399H51.5779Z"
          fill="url(#paint101_linear_1886_6847)"
        />
        <path
          d="M51.3633 155.182C39.9751 155.182 28.8027 150.469 22.9145 143.162L17.5224 136.482L32.0595 122.948L38.2712 130.299C40.2339 132.633 45.4751 135.12 51.277 135.12C57.0789 135.12 59.322 133.714 60.0769 133.109C60.8534 132.504 61.1553 131.834 61.1553 130.774C61.1553 129.174 61.1553 128.029 49.5515 125.197C43.9653 123.835 38.1849 122.429 33.1811 119.295C26.236 114.949 22.5694 108.269 22.5694 99.9239C22.5694 87.7307 31.6713 75.4294 52.0319 75.4294C60.4436 75.4294 69.1141 78.2183 75.1964 82.888L82.1198 88.2063L70.8611 104.615L63.2259 99.0158C60.271 96.8323 56.0005 95.4919 52.0966 95.4919C48.5594 95.4919 42.628 96.0756 42.628 100.01C42.628 101.891 43.1457 102.994 54.426 105.783C59.9691 107.145 65.6847 108.55 70.6454 111.641C77.5473 115.944 81.1924 122.559 81.1924 130.774C81.1924 137.779 78.2375 144.092 72.8886 148.502C67.518 152.934 60.271 155.182 51.2986 155.182H51.3633Z"
          fill="url(#paint102_linear_1886_6847)"
        />
        <path
          d="M51.1486 154.966C39.7605 154.966 28.588 150.253 22.6998 142.945L17.3077 136.265L31.8449 122.732L38.0566 130.082C40.0193 132.417 45.2604 134.903 51.0624 134.903C56.8643 134.903 59.1073 133.498 59.8622 132.893C60.6387 132.287 60.9407 131.617 60.9407 130.558C60.9407 128.958 60.9407 127.812 49.3369 124.98C43.7506 123.618 37.9703 122.213 32.9664 119.078C26.0214 114.733 22.3547 108.052 22.3547 99.7073C22.3547 87.5142 31.4566 75.2129 51.8172 75.2129C60.2289 75.2129 68.8994 78.0018 74.9817 82.6715L81.9052 87.9898L70.6465 104.399L63.0112 98.7993C60.0564 96.6158 55.7858 95.2754 51.8819 95.2754C48.3447 95.2754 42.4134 95.8591 42.4134 99.7938C42.4134 101.675 42.931 102.777 54.2113 105.566C59.7544 106.928 65.4701 108.333 70.4308 111.425C77.3327 115.727 80.9778 122.342 80.9778 130.558C80.9778 137.562 78.0229 143.875 72.6739 148.285C67.3034 152.717 60.0564 154.966 51.0839 154.966H51.1486Z"
          fill="url(#paint103_linear_1886_6847)"
        />
        <path
          d="M50.9312 154.75C39.543 154.75 28.3706 150.037 22.4824 142.73L17.0903 136.05L31.6274 122.516L37.8392 129.867C39.8019 132.202 45.043 134.688 50.8449 134.688C56.6468 134.688 58.8899 133.283 59.6448 132.677C60.4213 132.072 60.7233 131.402 60.7233 130.343C60.7233 128.743 60.7232 127.597 49.1194 124.765C43.5332 123.403 37.7529 121.998 32.749 118.863C25.804 114.517 22.1373 107.837 22.1373 99.4922C22.1373 87.299 31.2392 74.9978 51.5998 74.9978C60.0115 74.9978 68.682 77.7866 74.7643 82.4563L81.6878 87.7746L70.4291 104.184L62.7938 98.5841C59.8389 96.4006 55.5684 95.0603 51.6645 95.0603C48.1273 95.0603 42.196 95.644 42.196 99.5786C42.196 101.46 42.7136 102.562 53.9939 105.351C59.537 106.713 65.2526 108.118 70.2134 111.21C77.1152 115.512 80.7603 122.127 80.7603 130.343C80.7603 137.347 77.8055 143.66 72.4565 148.07C67.0859 152.502 59.8389 154.75 50.8665 154.75H50.9312Z"
          fill="url(#paint104_linear_1886_6847)"
        />
        <path
          d="M50.7165 154.534C39.3284 154.534 28.156 149.821 22.2678 142.514L16.8757 135.833L31.4128 122.3L37.6245 129.65C39.5872 131.985 44.8283 134.471 50.6302 134.471C56.4322 134.471 58.6753 133.066 59.4302 132.461C60.2066 131.856 60.5086 131.185 60.5086 130.126C60.5086 128.526 60.5086 127.38 48.9048 124.548C43.3186 123.186 37.5382 121.781 32.5343 118.646C25.5893 114.301 21.9227 107.621 21.9227 99.2756C21.9227 87.0825 31.0246 74.7812 51.3852 74.7812C59.7968 74.7812 68.4674 77.5701 74.5497 82.2398L81.4731 87.5581L70.2144 103.967L62.5792 98.3676C59.6243 96.1841 55.3537 94.8437 51.4499 94.8437C47.9126 94.8437 41.9813 95.4274 41.9813 99.3621C41.9813 101.243 42.499 102.346 53.7793 105.134C59.3223 106.496 65.038 107.902 69.9987 110.993C76.9006 115.295 80.5457 121.911 80.5457 130.126C80.5457 137.131 77.5908 143.443 72.2418 147.854C66.8713 152.285 59.6243 154.534 50.6518 154.534H50.7165Z"
          fill="url(#paint105_linear_1886_6847)"
        />
        <path
          d="M50.4991 154.317C39.1109 154.317 27.9385 149.604 22.0503 142.297L16.6582 135.617L31.1953 122.083L37.4071 129.434C39.3698 131.769 44.6109 134.255 50.4128 134.255C56.2147 134.255 58.4578 132.85 59.2127 132.244C59.9892 131.639 60.2912 130.969 60.2912 129.909C60.2912 128.31 60.2911 127.164 48.6873 124.332C43.1011 122.97 37.3208 121.565 32.3169 118.43C25.3719 114.084 21.7052 107.404 21.7052 99.059C21.7052 86.8659 30.8071 74.5647 51.1677 74.5647C59.5794 74.5647 68.2499 77.3536 74.3322 82.0233L81.2557 87.3416L69.9969 103.75L62.3617 98.1511C59.4068 95.9676 55.1363 94.6272 51.2324 94.6272C47.6952 94.6272 41.7639 95.2109 41.7639 99.1455C41.7639 101.026 42.2815 102.129 53.5618 104.918C59.1049 106.28 64.8205 107.685 69.7812 110.777C76.6831 115.079 80.3282 121.694 80.3282 129.909C80.3282 136.914 77.3733 143.227 72.0244 147.637C66.6538 152.069 59.4068 154.317 50.4344 154.317H50.4991Z"
          fill="url(#paint106_linear_1886_6847)"
        />
        <path
          d="M50.2844 154.101C38.8963 154.101 27.7238 149.388 21.8356 142.081L16.4435 135.4L30.9806 121.867L37.1924 129.217C39.1551 131.552 44.3962 134.038 50.1981 134.038C56 134.038 58.2431 132.633 58.998 132.028C59.7745 131.422 60.0765 130.752 60.0765 129.693C60.0765 128.093 60.0765 126.947 48.4726 124.115C42.8864 122.753 37.1061 121.348 32.1022 118.213C25.1572 113.868 21.4905 107.188 21.4905 98.8426C21.4905 86.6494 30.5924 74.3481 50.953 74.3481C59.3647 74.3481 68.0352 77.137 74.1175 81.8067L81.041 87.125L69.7823 103.534L62.147 97.9345C59.1922 95.751 54.9216 94.4106 51.0177 94.4106C47.4805 94.4106 41.5492 94.9943 41.5492 98.929C41.5492 100.81 42.0668 101.912 53.3471 104.701C58.8902 106.063 64.6058 107.469 69.5666 110.56C76.4685 114.862 80.1135 121.478 80.1135 129.693C80.1135 136.697 77.1587 143.01 71.8097 147.421C66.4392 151.852 59.1922 154.101 50.2197 154.101H50.2844Z"
          fill="url(#paint107_linear_1886_6847)"
        />
        <path
          d="M50.0698 153.886C38.6816 153.886 27.5092 149.173 21.621 141.866L16.2289 135.185L30.766 121.652L36.9777 129.002C38.9404 131.337 44.1816 133.823 49.9835 133.823C55.7854 133.823 58.0285 132.418 58.7834 131.813C59.5598 131.207 59.8618 130.537 59.8618 129.478C59.8618 127.878 59.8618 126.732 48.258 123.9C42.6718 122.538 36.8915 121.133 31.8876 117.998C24.9425 113.653 21.2759 106.972 21.2759 98.6275C21.2759 86.4343 30.3778 74.1331 50.7384 74.1331C59.1501 74.1331 67.8206 76.9219 73.9029 81.5917L80.8263 86.9099L69.5676 103.319L61.9324 97.7194C58.9775 95.5359 54.707 94.1955 50.8031 94.1955C47.2659 94.1955 41.3345 94.7793 41.3345 98.714C41.3345 100.595 41.8522 101.697 53.1325 104.486C58.6756 105.848 64.3912 107.253 69.3519 110.345C76.2538 114.647 79.8989 121.263 79.8989 129.478C79.8989 136.482 76.944 142.795 71.595 147.205C66.2245 151.637 58.9775 153.886 50.0051 153.886H50.0698Z"
          fill="url(#paint108_linear_1886_6847)"
        />
        <path
          d="M49.8523 153.669C38.4641 153.669 27.2917 148.956 21.4035 141.649L16.0114 134.969L30.5485 121.435L36.7602 128.786C38.723 131.12 43.9641 133.607 49.766 133.607C55.5679 133.607 57.811 132.201 58.5659 131.596C59.3424 130.991 59.6443 130.321 59.6443 129.261C59.6443 127.661 59.6443 126.516 48.0405 123.684C42.4543 122.322 36.674 120.916 31.6701 117.782C24.725 113.436 21.0584 106.756 21.0584 98.4109C21.0584 86.2177 30.1603 73.9165 50.5209 73.9165C58.9326 73.9165 67.6031 76.7053 73.6854 81.375L80.6089 86.6933L69.3501 103.102L61.7149 97.5028C58.76 95.3193 54.4895 93.979 50.5856 93.979C47.0484 93.979 41.1171 94.5627 41.1171 98.4973C41.1171 100.378 41.6347 101.481 52.915 104.27C58.4581 105.632 64.1737 107.037 69.1344 110.128C76.0363 114.431 79.6814 121.046 79.6814 129.261C79.6814 136.266 76.7265 142.579 71.3776 146.989C66.007 151.421 58.76 153.669 49.7875 153.669H49.8523Z"
          fill="url(#paint109_linear_1886_6847)"
        />
        <path
          d="M49.6376 153.453C38.2495 153.453 27.077 148.74 21.1889 141.432L15.7968 134.752L30.3339 121.219L36.5456 128.569C38.5083 130.904 43.7494 133.39 49.5513 133.39C55.3532 133.39 57.5964 131.985 58.3513 131.38C59.1277 130.774 59.4297 130.104 59.4297 129.045C59.4297 127.445 59.4297 126.299 47.8259 123.467C42.2397 122.105 36.4593 120.7 31.4554 117.565C24.5104 113.22 20.8438 106.539 20.8438 98.1943C20.8438 86.0012 29.9456 73.7 50.3062 73.7C58.7179 73.7 67.3884 76.4888 73.4707 81.1585L80.3942 86.4768L69.1355 102.886L61.5003 97.2863C58.5454 95.1028 54.2748 93.7624 50.3709 93.7624C46.8337 93.7624 40.9024 94.3461 40.9024 98.2808C40.9024 100.162 41.42 101.264 52.7003 104.053C58.2434 105.415 63.9591 106.82 68.9198 109.912C75.8217 114.214 79.4668 120.829 79.4668 129.045C79.4668 136.049 76.5119 142.362 71.1629 146.772C65.7924 151.204 58.5454 153.453 49.5729 153.453H49.6376Z"
          fill="url(#paint110_linear_1886_6847)"
        />
        <path
          d="M49.423 153.236C38.0348 153.236 26.8624 148.523 20.9742 141.216L15.5821 134.536L30.1192 121.002L36.3309 128.353C38.2937 130.687 43.5348 133.174 49.3367 133.174C55.1386 133.174 57.3817 131.768 58.1366 131.163C58.9131 130.558 59.215 129.888 59.215 128.828C59.215 127.228 59.215 126.083 47.6112 123.25C42.025 121.888 36.2447 120.483 31.2408 117.348C24.2958 113.003 20.6291 106.323 20.6291 97.9778C20.6291 85.7846 29.731 73.4834 50.0916 73.4834C58.5033 73.4834 67.1738 76.2723 73.2561 80.942L80.1796 86.2603L68.9208 102.669L61.2856 97.0698C58.3307 94.8863 54.0602 93.5459 50.1563 93.5459C46.6191 93.5459 40.6877 94.1296 40.6877 98.0642C40.6877 99.9451 41.2054 101.048 52.4857 103.837C58.0288 105.199 63.7444 106.604 68.7051 109.695C75.607 113.997 79.2521 120.613 79.2521 128.828C79.2521 135.833 76.2972 142.145 70.9482 146.556C65.5777 150.988 58.3307 153.236 49.3583 153.236H49.423Z"
          fill="url(#paint111_linear_1886_6847)"
        />
        <path
          d="M49.2056 153.021C37.8174 153.021 26.645 148.308 20.7568 141.001L15.3647 134.321L29.9018 120.787L36.1135 128.137C38.0762 130.472 43.3174 132.959 49.1193 132.959C54.9212 132.959 57.1643 131.553 57.9192 130.948C58.6957 130.343 58.9976 129.672 58.9976 128.613C58.9976 127.013 58.9976 125.867 47.3938 123.035C41.8076 121.673 36.0272 120.268 31.0234 117.133C24.0783 112.788 20.4117 106.108 20.4117 97.7627C20.4117 85.5696 29.5136 73.2683 49.8742 73.2683C58.2859 73.2683 66.9563 76.0572 73.0386 80.7269L79.9621 86.0452L68.7034 102.454L61.0682 96.8547C58.1133 94.6712 53.8428 93.3308 49.9389 93.3308C46.4017 93.3308 40.4703 93.9145 40.4703 97.8492C40.4703 99.73 40.988 100.833 52.2683 103.621C57.8114 104.983 63.527 106.389 68.4877 109.48C75.3896 113.782 79.0347 120.398 79.0347 128.613C79.0347 135.618 76.0798 141.93 70.7308 146.341C65.3603 150.773 58.1133 153.021 49.1409 153.021H49.2056Z"
          fill="url(#paint112_linear_1886_6847)"
        />
        <path
          d="M49.2045 153.021C37.8163 153.021 26.6439 148.308 20.7557 141.001L15.3636 134.321L29.9007 120.787L36.1124 128.137C38.0751 130.472 43.3163 132.959 49.1182 132.959C54.9201 132.959 57.1632 131.553 57.9181 130.948C58.6946 130.343 58.9965 129.672 58.9965 128.613C58.9965 127.013 58.9965 125.867 47.3927 123.035C41.8065 121.673 36.0261 120.268 31.0223 117.133C24.0772 112.788 20.4106 106.108 20.4106 97.7627C20.4106 85.5696 29.5125 73.2683 49.8731 73.2683C58.2848 73.2683 66.9552 76.0572 73.0375 80.7269L79.961 86.0452L68.7023 102.454L61.0671 96.8547C58.1122 94.6712 53.8417 93.3308 49.9378 93.3308C46.4006 93.3308 40.4692 93.9145 40.4692 97.8492C40.4692 99.73 40.9869 100.833 52.2672 103.621C57.8103 104.983 63.5259 106.389 68.4866 109.48C75.3885 113.782 79.0336 120.398 79.0336 128.613C79.0336 135.618 76.0787 141.93 70.7297 146.341C65.3592 150.773 58.1122 153.021 49.1398 153.021H49.2045Z"
          fill="url(#paint113_linear_1886_6847)"
        />
        <path
          d="M49.2053 151.485C38.2701 151.485 27.5506 146.988 21.9428 140.049L17.4349 134.471L29.7505 122.991L34.9269 129.131C37.1701 131.79 42.7778 134.492 49.119 134.492C55.0071 134.492 57.7679 133.022 58.8679 132.158C60.011 131.25 60.5287 130.147 60.5287 128.612C60.5287 125.564 58.8463 124.267 47.7601 121.543C42.3033 120.202 36.6524 118.84 31.8427 115.835C25.3721 111.792 21.9643 105.545 21.9643 97.7617C21.9643 86.3253 30.5917 74.8022 49.8954 74.8022C57.9836 74.8022 66.309 77.4614 72.1325 81.9366L77.9128 86.3685L68.3796 100.27L62.0169 95.5998C58.8032 93.2433 54.1876 91.7732 49.9817 91.7732C45.7759 91.7732 39.0034 92.5515 39.0034 97.8266C39.0034 100.983 40.7073 102.302 51.966 105.091C57.3797 106.431 62.9875 107.815 67.7541 110.755C74.1815 114.754 77.5893 120.916 77.5893 128.59C77.5893 135.141 74.8285 141.021 69.8462 145.151C64.7561 149.345 57.8326 151.463 49.2268 151.463L49.2053 151.485Z"
          fill="url(#paint114_linear_1886_6847)"
        />
        <path
          d="M60.5287 128.375C60.5287 128.375 60.5287 128.548 60.5287 128.613C60.5287 130.169 60.011 131.25 58.8679 132.158C57.7463 133.023 55.0071 134.493 49.119 134.493C42.7778 134.493 37.1916 131.791 34.9269 129.132L29.7505 122.992L17.4349 134.471L19.3977 136.893L31.2172 125.91L36.3936 132.05C38.6367 134.709 44.2445 137.412 50.5856 137.412C56.4738 137.412 59.2346 135.942 60.3345 135.077C61.4777 134.169 61.9953 133.066 61.9953 131.531C61.9953 130.256 61.6934 129.283 60.5502 128.396L60.5287 128.375ZM67.7325 110.777C62.9875 107.815 57.3797 106.432 51.9444 105.113C45.3661 103.491 42.0661 102.367 40.4269 101.07C40.5563 103.989 42.519 105.329 53.3895 108.01C58.8032 109.35 64.411 110.734 69.1776 113.674C72.1541 115.512 74.4619 117.825 76.1011 120.527C74.5266 116.549 71.7227 113.242 67.7325 110.777ZM72.1325 81.9588C66.309 77.4836 57.9836 74.8245 49.8954 74.8245C30.5917 74.8245 21.9643 86.3474 21.9643 97.7839C21.9643 102 22.978 105.761 24.9192 108.961C23.927 106.453 23.4094 103.686 23.4094 100.681C23.4094 89.2443 32.0368 77.7214 51.3405 77.7214C59.4287 77.7214 67.7541 80.3806 73.5776 84.8557L77.0932 87.5581L77.8912 86.3907L72.1109 81.9588H72.1325Z"
          fill="url(#paint115_linear_1886_6847)"
        />
        <rect
          x="-53.9995"
          y="0.000244141"
          width="204.9"
          height="227"
          fill="url(#pattern3_1886_6847)"
        />
        <path
          d="M28.9267 138.571C28.1771 138.571 27.4275 138.257 26.8984 137.718C26.7661 137.584 26.6559 137.427 26.5456 137.27C26.4354 137.112 26.3472 136.955 26.2811 136.776C26.215 136.596 26.1488 136.417 26.1047 136.237C26.0606 136.058 26.0386 135.856 26.0386 135.654C26.0386 134.891 26.3472 134.128 26.8764 133.59C27.0086 133.455 27.163 133.343 27.3173 133.231C27.4716 133.119 27.648 133.029 27.8023 132.961C27.9787 132.894 28.1551 132.827 28.3315 132.804C29.2574 132.602 30.2495 132.917 30.9109 133.59C31.4401 134.128 31.7487 134.891 31.7487 135.654C31.7487 135.834 31.7487 136.035 31.7046 136.237C31.6605 136.417 31.6164 136.596 31.5283 136.776C31.4621 136.955 31.3739 137.112 31.2637 137.27C31.1534 137.427 31.0432 137.584 30.9109 137.718C30.7787 137.853 30.6243 137.965 30.47 138.077C30.3157 138.189 30.1393 138.279 29.985 138.346C29.8086 138.414 29.6322 138.481 29.4558 138.504C29.2574 138.548 29.0811 138.571 28.8826 138.571H28.9267Z"
          fill="#FFD488"
        />
        <path
          d="M48.5246 146.94C46.9373 146.895 45.7027 145.571 45.7468 143.955C45.7908 142.34 47.0916 141.061 48.679 141.106C50.2664 141.151 51.501 142.497 51.4569 144.09C51.4128 145.683 50.1341 146.94 48.5908 146.94H48.5026H48.5246ZM56.6599 143.484C56.1308 141.958 56.9245 140.298 58.4237 139.782C59.9229 139.243 61.5544 140.051 62.0835 141.577C62.6126 143.103 61.8189 144.763 60.3197 145.302C60.0111 145.414 59.6804 145.459 59.3717 145.459C58.1812 145.459 57.0788 144.696 56.6599 143.507V143.484ZM36.8619 144.539C35.3847 143.955 34.6572 142.25 35.2525 140.747C35.8257 139.243 37.5012 138.503 38.9784 139.109C40.4555 139.692 41.1831 141.397 40.5878 142.901C40.1469 144.045 39.0665 144.741 37.9201 144.741C37.5674 144.741 37.2146 144.673 36.8619 144.539ZM66.3606 138.279C64.9275 137.561 64.3543 135.811 65.0598 134.375C65.7653 132.938 67.485 132.333 68.896 133.051C70.307 133.769 70.9022 135.519 70.1967 136.955C69.6896 137.987 68.6755 138.57 67.6172 138.57C67.1983 138.57 66.7574 138.481 66.3606 138.279ZM65.3023 126.05C64.663 124.569 65.3464 122.842 66.8015 122.213C68.2566 121.585 69.9322 122.258 70.5715 123.739C71.2109 125.22 70.5274 126.948 69.0723 127.576C68.6975 127.733 68.3227 127.823 67.9259 127.823C66.8236 127.823 65.7653 127.172 65.3023 126.073V126.05ZM58.7765 120.575C57.2993 119.97 56.5938 118.264 57.2111 116.783C57.8064 115.28 59.4819 114.562 60.937 115.168C62.4142 115.774 63.1197 117.479 62.5024 118.982C62.0614 120.127 60.9811 120.8 59.8567 120.8C59.504 120.8 59.1292 120.732 58.7765 120.575ZM48.657 117.614C47.1137 117.232 46.1656 115.661 46.5404 114.091C46.9152 112.52 48.4585 111.555 50.0018 111.937C51.5451 112.318 52.4931 113.889 52.1183 115.46C51.8096 116.783 50.6191 117.681 49.3404 117.681C49.1199 117.681 48.8774 117.658 48.657 117.591V117.614ZM37.6997 114.203C36.2446 113.552 35.5831 111.847 36.2225 110.366C36.8619 108.885 38.5374 108.212 39.9925 108.863C41.4476 109.514 42.109 111.219 41.4697 112.7C41.0067 113.799 39.9484 114.45 38.8461 114.45C38.4713 114.45 38.0745 114.36 37.6997 114.203ZM28.1974 105.699C27.514 104.241 28.1093 102.491 29.5423 101.795C30.9753 101.099 32.695 101.705 33.3785 103.164C34.0619 104.622 33.4667 106.372 32.0336 107.068C31.6368 107.27 31.1958 107.36 30.777 107.36C29.7187 107.36 28.6825 106.754 28.1974 105.699ZM29.2557 96.3651C27.7345 95.8939 26.8746 94.2784 27.3376 92.7302C27.8006 91.182 29.388 90.307 30.9092 90.7782C32.4305 91.2494 33.2903 92.8649 32.8273 94.4131C32.4525 95.6696 31.3061 96.4773 30.0714 96.4773C29.8069 96.4773 29.5203 96.4324 29.2557 96.3651ZM34.3265 86.6047C33.5328 85.2136 34.0178 83.4186 35.3847 82.6108C36.7516 81.8031 38.5154 82.2743 39.3091 83.6879C40.1028 85.079 39.6177 86.874 38.2508 87.6818C37.8099 87.951 37.3028 88.0632 36.8178 88.0632C35.8257 88.0632 34.8556 87.5471 34.3265 86.6047ZM57.4316 85.9316C55.8883 85.5278 54.9623 83.9571 55.3592 82.3864C55.756 80.8158 57.2993 79.8734 58.8426 80.2773C60.3859 80.6812 61.3118 82.2519 60.915 83.8225C60.5843 85.1463 59.4158 86.0213 58.1371 86.0213C57.8946 86.0213 57.6521 85.9989 57.4316 85.9316ZM44.4019 82.4089C44.2917 80.7934 45.4601 79.4022 47.0475 79.29C48.6349 79.1779 50.0018 80.3671 50.112 81.9826C50.2223 83.5981 49.0538 84.9892 47.4664 85.1238C47.4664 85.1238 47.3121 85.1238 47.2459 85.1238C45.7688 85.1238 44.5121 83.9571 44.3799 82.4314L44.4019 82.4089Z"
          fill="#FFE0A9"
        />
        <path
          d="M68.1666 90.7786C67.9682 90.7786 67.7918 90.7786 67.6154 90.7113C67.4391 90.6665 67.2406 90.6216 67.0863 90.5543C66.9099 90.4869 66.7556 90.3972 66.6013 90.285C66.447 90.1728 66.2926 90.0606 66.1603 89.926C65.6312 89.3875 65.3226 88.6246 65.3226 87.8617C65.3226 87.0988 65.6312 86.336 66.1603 85.7975C66.2926 85.6629 66.447 85.5507 66.6013 85.4385C66.7556 85.3263 66.932 85.2365 67.0863 85.1692C67.2627 85.1019 67.4391 85.0346 67.6154 85.0122C67.9902 84.9448 68.365 84.9448 68.7398 85.0122C68.9162 85.057 69.0926 85.1019 69.2689 85.1692C69.4453 85.2365 69.5996 85.3263 69.754 85.4385C69.9083 85.5507 70.0626 85.6629 70.1949 85.7975C70.724 86.336 71.0327 87.0988 71.0327 87.8617C71.0327 88.0636 71.0327 88.2432 70.9666 88.4451C70.9225 88.6246 70.8784 88.8041 70.8122 88.9836C70.7461 89.1631 70.6579 89.3202 70.5477 89.4772C70.4374 89.6343 70.3272 89.7914 70.1949 89.926C70.0626 90.0606 69.9083 90.1728 69.754 90.285C69.5996 90.3972 69.4233 90.4869 69.2689 90.5543C69.0926 90.6216 68.9162 90.6889 68.7398 90.7113C68.5414 90.7562 68.365 90.7786 68.1666 90.7786Z"
          fill="#FFD488"
        />
        <path
          d="M28.9211 137.495C28.8109 137.495 28.6787 137.495 28.5684 137.45C28.4582 137.45 28.3479 137.383 28.2377 137.338C28.1275 137.293 28.0172 137.226 27.929 137.159C27.8409 137.091 27.7306 137.024 27.6424 136.934C27.5542 136.844 27.4881 136.755 27.422 136.642C27.3558 136.553 27.3117 136.441 27.2456 136.328C27.2015 136.216 27.1574 136.104 27.1354 135.992C27.1354 135.88 27.0912 135.745 27.0912 135.633C27.0912 135.521 27.0913 135.386 27.1354 135.274C27.1574 135.162 27.2015 135.027 27.2456 134.915C27.2897 134.803 27.3558 134.69 27.422 134.601C27.4881 134.489 27.5763 134.399 27.6424 134.309C27.7306 134.219 27.8188 134.152 27.929 134.085C28.0393 134.017 28.1275 133.972 28.2377 133.905C28.3479 133.86 28.4582 133.815 28.5684 133.793C28.8109 133.748 29.0534 133.748 29.2739 133.793C29.3841 133.815 29.4944 133.86 29.6046 133.905C29.7148 133.95 29.8251 134.017 29.9133 134.085C30.0015 134.152 30.1117 134.242 30.1999 134.309C30.2881 134.399 30.3542 134.489 30.4203 134.601C30.4865 134.713 30.5526 134.803 30.5967 134.915C30.6408 135.027 30.6849 135.139 30.7069 135.274C30.729 135.386 30.751 135.521 30.751 135.633C30.751 135.745 30.751 135.88 30.7069 135.992C30.7069 136.104 30.6408 136.216 30.5967 136.328C30.5526 136.441 30.4865 136.553 30.4203 136.642C30.3542 136.755 30.2881 136.844 30.1999 136.934C29.8692 137.271 29.3841 137.473 28.8991 137.473L28.9211 137.495Z"
          fill="white"
        />
        <path
          d="M48.5478 145.887C47.5337 145.865 46.74 145.012 46.762 143.98C46.7841 142.948 47.6218 142.14 48.636 142.163C49.6501 142.185 50.4438 143.038 50.4218 144.07C50.3997 145.079 49.584 145.887 48.6139 145.887H48.5698H48.5478ZM57.6531 143.127C57.3224 142.162 57.8295 141.108 58.7775 140.771C59.7256 140.435 60.7618 140.951 61.0925 141.916C61.4232 142.88 60.9161 143.935 59.9681 144.272C59.7696 144.339 59.5712 144.384 59.3728 144.384C58.6232 144.384 57.9177 143.913 57.6531 143.15V143.127ZM37.2378 143.554C36.3118 143.172 35.8488 142.095 36.2016 141.153C36.5763 140.188 37.6346 139.739 38.5826 140.098C39.5306 140.48 39.9716 141.557 39.6188 142.499C39.3322 143.24 38.6488 143.666 37.9212 143.666C37.7007 143.666 37.4803 143.621 37.2598 143.531L37.2378 143.554ZM66.8246 137.316C65.9207 136.867 65.5459 135.745 65.9868 134.825C66.4278 133.905 67.5301 133.524 68.4341 133.973C69.338 134.422 69.7128 135.543 69.2498 136.463C68.9412 137.114 68.2797 137.495 67.6183 137.495C67.3317 137.495 67.0672 137.428 66.8026 137.294L66.8246 137.316ZM66.2735 125.626C65.8766 124.684 66.2735 123.584 67.2215 123.18C68.1475 122.776 69.2278 123.18 69.6246 124.145C70.0214 125.087 69.6025 126.187 68.6766 126.591C68.4341 126.703 68.1916 126.748 67.9491 126.748C67.2436 126.748 66.5821 126.322 66.2735 125.626ZM59.1523 119.59C58.2264 119.209 57.7634 118.109 58.1602 117.167C58.535 116.225 59.5933 115.753 60.5413 116.157C61.4673 116.539 61.9302 117.616 61.5334 118.581C61.2468 119.299 60.5633 119.747 59.8358 119.747C59.6153 119.747 59.3728 119.702 59.1523 119.613V119.59ZM48.9005 116.584C47.9305 116.337 47.3132 115.327 47.5557 114.34C47.7982 113.353 48.7903 112.724 49.7604 112.971C50.7305 113.218 51.3477 114.228 51.1052 115.215C50.9068 116.068 50.1572 116.628 49.3415 116.628C49.1872 116.628 49.0549 116.628 48.9005 116.584ZM38.1196 113.24C37.1937 112.836 36.7748 111.737 37.1716 110.795C37.5685 109.852 38.6488 109.426 39.5747 109.83C40.5007 110.234 40.9196 111.333 40.5228 112.276C40.2141 112.971 39.5527 113.397 38.8472 113.397C38.6047 113.397 38.3621 113.353 38.1196 113.24ZM29.1466 105.23C28.7056 104.31 29.0804 103.188 30.0064 102.74C30.9103 102.291 32.0127 102.672 32.4536 103.615C32.8945 104.535 32.5197 105.656 31.5938 106.083C31.3292 106.217 31.0646 106.262 30.8001 106.262C30.1166 106.262 29.4773 105.881 29.1466 105.208V105.23ZM29.5434 95.3576C28.5733 95.0659 28.0222 94.0337 28.3308 93.0465C28.6175 92.0592 29.6316 91.4983 30.6017 91.79C31.5717 92.0817 32.1229 93.1138 31.8363 94.1011C31.5938 94.9088 30.8882 95.4249 30.0946 95.4249C29.9182 95.4249 29.7418 95.4249 29.5655 95.3352L29.5434 95.3576ZM35.2315 86.0908C34.7244 85.2157 35.0331 84.0715 35.8929 83.5554C36.7527 83.0393 37.8771 83.3534 38.3842 84.2285C38.8913 85.126 38.5826 86.2479 37.7228 86.764C37.4362 86.921 37.1275 87.0108 36.8189 87.0108C36.1795 87.0108 35.5622 86.6742 35.2315 86.0908ZM57.6752 84.9016C56.7051 84.6548 56.1099 83.6451 56.3524 82.6578C56.5949 81.6706 57.587 81.0648 58.5571 81.3116C59.5271 81.5585 60.1224 82.5681 59.8799 83.5554C59.6815 84.408 58.9319 84.9465 58.1161 84.9465C57.9618 84.9465 57.8295 84.9465 57.6752 84.8792V84.9016ZM45.4612 82.3213C45.373 81.2892 46.1227 80.4141 47.1368 80.3244C48.151 80.2346 49.0108 81.0199 49.099 82.0296C49.1872 83.0617 48.4155 83.9368 47.4234 84.0266C47.4234 84.0266 47.3352 84.0266 47.2911 84.0266C46.3431 84.0266 45.5494 83.2862 45.4833 82.2989L45.4612 82.3213Z"
          fill="white"
        />
        <path
          d="M68.1678 89.7025C68.0575 89.7025 67.9253 89.7025 67.815 89.6577C67.7048 89.6577 67.5946 89.5903 67.4623 89.5454C67.3521 89.5005 67.2418 89.4333 67.1536 89.366C67.0655 89.2986 66.9552 89.2313 66.867 89.1416C66.5363 88.805 66.3379 88.3114 66.3379 87.8177C66.3379 87.7056 66.3379 87.5709 66.382 87.4587C66.404 87.3466 66.4481 87.2344 66.4922 87.0997C66.5363 86.9875 66.6025 86.8754 66.6686 86.7856C66.7348 86.6734 66.8229 86.5837 66.8891 86.4939C67.308 86.0676 67.9473 85.8657 68.5426 85.9778C68.6528 86.0003 68.7631 86.0451 68.8733 86.09C68.9835 86.1349 69.0938 86.2022 69.182 86.2695C69.2701 86.3369 69.3804 86.4266 69.4685 86.4939C69.5567 86.5837 69.6229 86.6734 69.689 86.7856C69.7552 86.8754 69.8213 86.9875 69.8654 87.0997C69.9095 87.2119 69.9536 87.3241 69.9756 87.4587C69.9977 87.5709 70.0197 87.7056 70.0197 87.8177C70.0197 88.3114 69.8213 88.7826 69.4906 89.1416C69.4024 89.2313 69.3142 89.2986 69.204 89.366C69.0938 89.4333 69.0056 89.5005 68.8953 89.5454C68.7851 89.5903 68.6749 89.6352 68.5646 89.6577C68.4544 89.6801 68.3221 89.7025 68.2119 89.7025H68.1678Z"
          fill="white"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M54.903 86.9624C54.4474 96.666 46.2234 104.16 36.5414 103.703C26.8594 103.246 19.3826 95.0037 19.8382 85.3001C20.2939 75.5964 28.5178 68.1029 38.1998 68.5596C47.8819 69.0163 55.3587 77.2587 54.903 86.9624Z"
          fill="url(#paint116_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M40.0707 74.9925C60.1332 81.9551 75.5045 90.2181 74.4065 93.4393C73.2886 96.6605 56.1207 93.6194 36.0581 86.6568C15.9956 79.6942 0.624385 71.4312 1.72233 68.21C2.84025 64.9888 20.0082 68.03 40.0707 74.9925Z"
          fill="url(#paint117_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M43.8641 82.8354C36.9171 102.943 28.6725 118.348 25.4585 117.248C22.2445 116.128 25.2788 98.9213 32.2258 78.8139C39.1729 58.7065 47.4175 43.3008 50.6315 44.4012C53.8454 45.5216 50.8111 62.728 43.8641 82.8354Z"
          fill="url(#paint118_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M43.0275 77.1925C55.5441 94.3989 63.4492 109.965 60.6944 111.985C57.9395 114.006 45.5826 101.662 33.066 84.4552C20.5494 67.2489 12.6442 51.6831 15.3991 49.6624C18.1539 47.6616 30.5108 59.9862 43.0275 77.1925Z"
          fill="url(#paint119_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M41.6896 85.7966C24.5217 98.3412 8.99073 106.264 6.9745 103.503C4.95827 100.742 17.2752 88.3575 34.4431 75.8129C51.611 63.2683 67.1421 55.3454 69.1583 58.1064C71.1546 60.8674 58.8575 73.2519 41.6896 85.7966Z"
          fill="url(#paint120_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M89.3388 135.522C88.3606 148.106 77.3811 157.51 64.8246 156.529C52.268 155.549 42.8856 144.545 43.8637 131.96C44.8419 119.376 55.8214 109.972 68.3779 110.953C80.9345 111.933 90.3169 122.937 89.3388 135.522Z"
          fill="url(#paint121_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M68.6185 127.919C88.681 134.881 104.052 143.144 102.954 146.366C101.836 149.587 84.6684 146.546 64.6059 139.583C44.5434 132.621 29.1722 124.357 30.2701 121.136C31.388 117.915 48.5559 120.956 68.6185 127.919Z"
          fill="url(#paint122_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M72.4119 135.762C65.4648 155.869 57.2203 171.275 54.0063 170.174C50.7923 169.054 53.8266 151.848 60.7736 131.74C67.7207 111.633 75.9653 96.227 79.1792 97.3274C82.3932 98.4479 79.3589 115.654 72.4119 135.762Z"
          fill="url(#paint123_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M71.5731 130.12C84.0897 147.326 91.9949 162.892 89.24 164.913C86.4852 166.933 74.1283 154.589 61.6117 137.382C49.0951 120.176 41.1899 104.61 43.9447 102.59C46.6996 100.589 59.0565 112.913 71.5731 130.12Z"
          fill="url(#paint124_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M70.2352 138.724C53.0673 151.268 37.5364 159.191 35.5202 156.43C33.5039 153.669 45.8209 141.285 62.9888 128.74C80.1567 116.196 95.6877 108.273 97.7039 111.034C99.7002 113.795 87.4032 126.179 70.2352 138.724Z"
          fill="url(#paint125_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M127.877 112.634C126.899 125.219 115.919 134.622 103.363 133.642C90.806 132.661 81.4235 121.657 82.4017 109.073C83.3799 96.4879 94.3594 87.0845 106.916 88.0648C119.472 89.0452 128.855 100.049 127.877 112.634Z"
          fill="url(#paint126_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M107.156 105.031C127.219 111.994 142.59 120.257 141.492 123.478C140.374 126.699 123.206 123.658 103.143 116.695C83.081 109.733 67.7097 101.47 68.8077 98.2486C69.9256 95.0274 87.0935 98.0685 107.156 105.031Z"
          fill="url(#paint127_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M110.949 112.874C104.002 132.981 95.7578 148.387 92.5438 147.287C89.3298 146.166 92.3642 128.96 99.3112 108.852C106.258 88.745 114.503 73.3393 117.717 74.4397C120.931 75.5602 117.896 92.7665 110.949 112.874Z"
          fill="url(#paint128_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M215.213 134.737C235.276 141.699 250.647 149.962 249.549 153.183C248.431 156.405 231.263 153.364 211.201 146.401C191.138 139.438 175.767 131.175 176.865 127.954C177.983 124.733 195.151 127.774 215.213 134.737Z"
          fill="url(#paint129_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M219.007 142.58C212.06 162.687 203.815 178.093 200.601 176.992C197.387 175.872 200.422 158.665 207.369 138.558C214.316 118.451 222.56 103.045 225.774 104.145C228.988 105.266 225.954 122.472 219.007 142.58Z"
          fill="url(#paint130_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M156.705 85.1217C176.767 92.0842 192.139 100.347 191.041 103.568C189.923 106.79 172.755 103.749 152.692 96.786C132.63 89.8234 117.259 81.5603 118.357 78.3391C119.474 75.118 136.642 78.1591 156.705 85.1217Z"
          fill="url(#paint131_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M160.498 92.9645C153.551 113.072 145.307 128.478 142.093 127.377C138.879 126.257 141.913 109.05 148.86 88.943C155.807 68.8356 164.052 53.4299 167.266 54.5303C170.48 55.6507 167.445 72.8571 160.498 92.9645Z"
          fill="url(#paint132_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M110.112 107.232C122.629 124.438 130.534 140.004 127.779 142.025C125.024 144.045 112.667 131.701 100.15 114.495C87.6339 97.2882 79.7287 81.7224 82.4836 79.7017C85.2384 77.7009 97.5953 90.0255 110.112 107.232Z"
          fill="url(#paint133_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M108.774 115.836C91.6061 128.381 76.0752 136.303 74.059 133.542C72.0427 130.781 84.3597 118.397 101.528 105.852C118.696 93.3076 134.227 85.3847 136.243 88.1457C138.239 90.9067 125.942 103.291 108.774 115.836Z"
          fill="url(#paint134_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M218.169 136.937C230.686 154.144 238.591 169.709 235.836 171.73C233.081 173.751 220.724 161.406 208.208 144.2C195.691 126.994 187.786 111.428 190.541 109.407C193.296 107.407 205.653 119.731 218.169 136.937Z"
          fill="url(#paint135_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M216.831 145.541C199.664 158.086 184.133 166.009 182.116 163.248C180.1 160.487 192.417 148.102 209.585 135.558C226.753 123.013 242.284 115.09 244.3 117.851C246.296 120.612 233.999 132.997 216.831 145.541Z"
          fill="url(#paint136_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M159.661 87.3224C172.177 104.529 180.083 120.094 177.328 122.115C174.573 124.136 162.216 111.791 149.699 94.5851C137.183 77.3788 129.278 61.813 132.032 59.7923C134.787 57.7915 147.144 70.1161 159.661 87.3224Z"
          fill="url(#paint137_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M158.323 95.9265C141.155 108.471 125.624 116.394 123.608 113.633C121.592 110.872 133.909 98.4874 151.076 85.9428C168.244 73.3982 183.775 65.4752 185.792 68.2363C187.788 70.9973 175.491 83.3818 158.323 95.9265Z"
          fill="url(#paint138_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M266.331 92.6082C265.352 105.193 254.373 114.596 241.816 113.616C229.26 112.636 219.877 101.632 220.856 89.0469C221.834 76.4623 232.813 67.0588 245.37 68.0392C257.926 69.0196 267.309 80.0236 266.331 92.6082Z"
          fill="url(#paint139_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M245.611 85.006C265.673 91.9685 281.044 100.232 279.946 103.453C278.828 106.674 261.661 103.633 241.598 96.6702C221.535 89.7077 206.164 81.4446 207.262 78.2234C208.38 75.0022 225.548 78.0434 245.611 85.006Z"
          fill="url(#paint140_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M249.404 92.8488C242.457 112.956 234.212 128.362 230.998 127.261C227.784 126.141 230.819 108.935 237.766 88.8273C244.713 68.7199 252.957 53.3142 256.171 54.4146C259.385 55.535 256.351 72.7414 249.404 92.8488Z"
          fill="url(#paint141_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M248.565 87.206C261.082 104.412 268.987 119.978 266.232 121.999C263.477 124.02 251.12 111.675 238.604 94.4687C226.087 77.2623 218.182 61.6965 220.937 59.6758C223.692 57.6751 236.049 69.9996 248.565 87.206Z"
          fill="url(#paint142_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M247.227 95.81C230.059 108.355 214.528 116.278 212.512 113.517C210.496 110.756 222.813 98.371 239.981 85.8263C257.149 73.2817 272.68 65.3588 274.696 68.1198C276.692 70.8808 264.395 83.2654 247.227 95.81Z"
          fill="url(#paint143_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M323.423 142.674C322.445 155.259 311.466 164.662 298.909 163.682C286.352 162.702 276.97 151.697 277.948 139.113C278.926 126.528 289.906 117.125 302.462 118.105C315.019 119.085 324.401 130.09 323.423 142.674Z"
          fill="url(#paint144_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M302.702 135.071C322.764 142.034 338.136 150.297 337.038 153.518C335.92 156.739 318.752 153.698 298.689 146.735C278.627 139.773 263.255 131.51 264.353 128.289C265.471 125.067 282.639 128.109 302.702 135.071Z"
          fill="url(#paint145_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M306.495 142.914C299.548 163.021 291.303 178.427 288.089 177.327C284.875 176.206 287.91 159 294.857 138.892C301.804 118.785 310.048 103.379 313.262 104.48C316.476 105.6 313.442 122.807 306.495 142.914Z"
          fill="url(#paint146_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M305.659 137.272C318.175 154.479 326.08 170.044 323.325 172.065C320.571 174.086 308.214 161.741 295.697 144.535C283.181 127.329 275.275 111.763 278.03 109.742C280.785 107.741 293.142 120.066 305.659 137.272Z"
          fill="url(#paint147_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M304.321 145.876C287.153 158.421 271.622 166.344 269.606 163.583C267.589 160.822 279.906 148.437 297.074 135.893C314.242 123.348 329.773 115.425 331.789 118.186C333.786 120.947 321.489 133.332 304.321 145.876Z"
          fill="url(#paint148_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M351.971 102.622C350.992 115.206 340.013 124.61 327.456 123.629C314.9 122.649 305.517 111.645 306.496 99.0604C307.474 86.4757 318.453 77.0723 331.01 78.0526C343.566 79.033 352.949 90.037 351.971 102.622Z"
          fill="url(#paint149_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M331.25 95.0194C351.312 101.982 366.683 110.245 365.585 113.466C364.468 116.687 347.3 113.646 327.237 106.684C307.175 99.7211 291.803 91.458 292.901 88.2369C294.019 85.0157 311.187 88.0568 331.25 95.0194Z"
          fill="url(#paint150_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M335.043 102.862C328.096 122.97 319.851 138.375 316.637 137.275C313.423 136.154 316.458 118.948 323.405 98.8407C330.352 78.7333 338.596 63.3276 341.81 64.428C345.024 65.5484 341.99 82.7548 335.043 102.862Z"
          fill="url(#paint151_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M334.206 97.2194C346.723 114.426 354.628 129.991 351.873 132.012C349.118 134.033 336.762 121.688 324.245 104.482C311.728 87.2757 303.823 71.71 306.578 69.6892C309.333 67.6885 321.69 80.0131 334.206 97.2194Z"
          fill="url(#paint152_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M332.869 105.823C315.701 118.368 300.17 126.291 298.153 123.53C296.137 120.769 308.454 108.384 325.622 95.8398C342.79 83.2951 358.321 75.3722 360.337 78.1332C362.334 80.8942 350.036 93.2788 332.869 105.823Z"
          fill="url(#paint153_radial_1886_6847)"
        />
        <path
          d="M38.2874 43.8169H31.5187V39.8167H49.9606V43.8169H43.1918V61.0262H38.2949V43.8169H38.2874Z"
          fill="#828282"
        />
        <path
          d="M75.1413 39.8167V61.0262H70.2444V52.3277H60.6303V61.0262H55.7335V39.8167H60.6303V48.1774H70.2444V39.8167H75.1413Z"
          fill="#828282"
        />
        <path
          d="M97.2984 57.086V61.0262H80.9156V39.8167H96.9091V43.7569H85.7825V48.365H95.6062V52.1851H85.7825V57.0935H97.2984V57.086Z"
          fill="#828282"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M36.1688 91.6971C31.8164 91.6971 28.2881 88.1609 28.2881 83.7988C28.2881 79.4366 31.8164 75.9004 36.1688 75.9004C40.5212 75.9004 44.0496 79.4366 44.0496 83.7988C44.0496 88.1609 40.5212 91.6971 36.1688 91.6971Z"
          fill="url(#paint154_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M38.4192 118.76C34.0668 118.76 30.5385 115.224 30.5385 110.861C30.5385 106.499 34.0668 102.963 38.4192 102.963C42.7716 102.963 46.2999 106.499 46.2999 110.861C46.2999 115.224 42.7716 118.76 38.4192 118.76Z"
          fill="url(#paint155_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M67.6734 131.164C63.321 131.164 59.7927 127.627 59.7927 123.265C59.7927 118.903 63.321 115.367 67.6734 115.367C72.0258 115.367 75.5541 118.903 75.5541 123.265C75.5541 127.627 72.0258 131.164 67.6734 131.164Z"
          fill="url(#paint156_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M47.4205 152.588C43.0681 152.588 39.5398 149.052 39.5398 144.69C39.5398 140.328 43.0681 136.792 47.4205 136.792C51.7729 136.792 55.3012 140.328 55.3012 144.69C55.3012 149.052 51.7729 152.588 47.4205 152.588Z"
          fill="url(#paint157_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M28.2927 143.567C23.9403 143.567 20.412 140.031 20.412 135.669C20.412 131.307 23.9403 127.771 28.2927 127.771C32.6451 127.771 36.1735 131.307 36.1735 135.669C36.1735 140.031 32.6451 143.567 28.2927 143.567Z"
          fill="url(#paint158_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M118.306 122.143C113.953 122.143 110.425 118.606 110.425 114.244C110.425 109.882 113.953 106.346 118.306 106.346C122.658 106.346 126.186 109.882 126.186 114.244C126.186 118.606 122.658 122.143 118.306 122.143Z"
          fill="url(#paint159_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M153.182 122.133C149.453 122.133 146.431 119.104 146.431 115.367C146.431 111.63 149.453 108.601 153.182 108.601C156.91 108.601 159.932 111.63 159.932 115.367C159.932 119.104 156.91 122.133 153.182 122.133Z"
          fill="url(#paint160_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M153.182 100.708C149.453 100.708 146.431 97.6788 146.431 93.9422C146.431 90.2056 149.453 87.1765 153.182 87.1765C156.91 87.1765 159.932 90.2056 159.932 93.9422C159.932 97.6788 156.91 100.708 153.182 100.708Z"
          fill="url(#paint161_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M153.182 90.5595C149.453 90.5595 146.431 87.5304 146.431 83.7938C146.431 80.0572 149.453 77.0281 153.182 77.0281C156.91 77.0281 159.932 80.0572 159.932 83.7938C159.932 87.5304 156.91 90.5595 153.182 90.5595Z"
          fill="url(#paint162_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M153.182 144.685C149.453 144.685 146.431 141.656 146.431 137.919C146.431 134.183 149.453 131.154 153.182 131.154C156.91 131.154 159.932 134.183 159.932 137.919C159.932 141.656 156.91 144.685 153.182 144.685Z"
          fill="url(#paint163_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M107.05 143.557C103.321 143.557 100.299 140.528 100.299 136.792C100.299 133.055 103.321 130.026 107.05 130.026C110.778 130.026 113.801 133.055 113.801 136.792C113.801 140.528 110.778 143.557 107.05 143.557Z"
          fill="url(#paint164_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M66.544 95.07C62.8155 95.07 59.793 92.0408 59.793 88.3043C59.793 84.5677 62.8155 81.5386 66.544 81.5386C70.2725 81.5386 73.295 84.5677 73.295 88.3043C73.295 92.0408 70.2725 95.07 66.544 95.07Z"
          fill="url(#paint165_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M202.689 143.557C198.96 143.557 195.938 140.528 195.938 136.792C195.938 133.055 198.96 130.026 202.689 130.026C206.417 130.026 209.44 133.055 209.44 136.792C209.44 140.528 206.417 143.557 202.689 143.557Z"
          fill="url(#paint166_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M197.063 104.091C193.334 104.091 190.312 101.062 190.312 97.3253C190.312 93.5887 193.334 90.5596 197.063 90.5596C200.791 90.5596 203.814 93.5887 203.814 97.3253C203.814 101.062 200.791 104.091 197.063 104.091Z"
          fill="url(#paint167_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M224.067 91.6871C220.338 91.6871 217.316 88.658 217.316 84.9215C217.316 81.1849 220.338 78.1558 224.067 78.1558C227.795 78.1558 230.818 81.1849 230.818 84.9215C230.818 88.658 227.795 91.6871 224.067 91.6871Z"
          fill="url(#paint168_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M243.195 140.174C239.466 140.174 236.444 137.145 236.444 133.409C236.444 129.672 239.466 126.643 243.195 126.643C246.923 126.643 249.946 129.672 249.946 133.409C249.946 137.145 246.923 140.174 243.195 140.174Z"
          fill="url(#paint169_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M248.82 130.026C245.092 130.026 242.069 126.997 242.069 123.26C242.069 119.524 245.092 116.495 248.82 116.495C252.549 116.495 255.571 119.524 255.571 123.26C255.571 126.997 252.549 130.026 248.82 130.026Z"
          fill="url(#paint170_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M291.577 121.005C287.848 121.005 284.826 117.976 284.826 114.239C284.826 110.503 287.848 107.474 291.577 107.474C295.305 107.474 298.328 110.503 298.328 114.239C298.328 117.976 295.305 121.005 291.577 121.005Z"
          fill="url(#paint171_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M284.826 101.836C281.097 101.836 278.075 98.8065 278.075 95.0699C278.075 91.3333 281.097 88.3042 284.826 88.3042C288.554 88.3042 291.577 91.3333 291.577 95.0699C291.577 98.8065 288.554 101.836 284.826 101.836Z"
          fill="url(#paint172_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M298.328 141.302C294.599 141.302 291.577 138.273 291.577 134.536C291.577 130.8 294.599 127.771 298.328 127.771C302.056 127.771 305.078 130.8 305.078 134.536C305.078 138.273 302.056 141.302 298.328 141.302Z"
          fill="url(#paint173_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M319.706 101.836C315.977 101.836 312.955 98.8065 312.955 95.0699C312.955 91.3333 315.977 88.3042 319.706 88.3042C323.434 88.3042 326.457 91.3333 326.457 95.0699C326.457 98.8065 323.434 101.836 319.706 101.836Z"
          fill="url(#paint174_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M337.708 131.154C333.98 131.154 330.957 128.125 330.957 124.388C330.957 120.651 333.98 117.622 337.708 117.622C341.437 117.622 344.459 120.651 344.459 124.388C344.459 128.125 341.437 131.154 337.708 131.154Z"
          fill="url(#paint175_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M344.459 151.451C340.731 151.451 337.708 148.421 337.708 144.685C337.708 140.948 340.731 137.919 344.459 137.919C348.188 137.919 351.21 140.948 351.21 144.685C351.21 148.421 348.188 151.451 344.459 151.451Z"
          fill="url(#paint176_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M354.586 121.005C350.857 121.005 347.835 117.976 347.835 114.239C347.835 110.503 350.857 107.474 354.586 107.474C358.314 107.474 361.337 110.503 361.337 114.239C361.337 117.976 358.314 121.005 354.586 121.005Z"
          fill="url(#paint177_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M361.337 101.836C357.608 101.836 354.586 98.8065 354.586 95.0699C354.586 91.3333 357.608 88.3042 361.337 88.3042C365.065 88.3042 368.088 91.3333 368.088 95.0699C368.088 98.8065 365.065 101.836 361.337 101.836Z"
          fill="url(#paint178_radial_1886_6847)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M364.712 91.6871C360.984 91.6871 357.961 88.658 357.961 84.9215C357.961 81.1849 360.984 78.1558 364.712 78.1558C368.441 78.1558 371.463 81.1849 371.463 84.9215C371.463 88.658 368.441 91.6871 364.712 91.6871Z"
          fill="url(#paint179_radial_1886_6847)"
        />
        <defs>
          <pattern
            id="pattern0_1886_6847"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use
              transform="scale(0.00869565 0.00961538)"
            />
          </pattern>
          <pattern
            id="pattern1_1886_6847"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use transform="scale(0.00961538)" />
          </pattern>
          <pattern
            id="pattern2_1886_6847"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use
              transform="scale(0.0102041 0.00952381)"
            />
          </pattern>
          <pattern
            id="pattern3_1886_6847"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use
              transform="scale(0.0105263 0.00952381)"
            />
          </pattern>
          <linearGradient
            id="paint0_linear_1886_6847"
            x1="328.783"
            y1="86.2215"
            x2="328.783"
            y2="162.256"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1886_6847"
            x1="328.568"
            y1="86.0065"
            x2="328.568"
            y2="162.041"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_1886_6847"
            x1="328.354"
            y1="85.7884"
            x2="328.354"
            y2="161.823"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_1886_6847"
            x1="328.136"
            y1="85.5733"
            x2="328.136"
            y2="161.608"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_1886_6847"
            x1="327.922"
            y1="85.3568"
            x2="327.922"
            y2="161.391"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_1886_6847"
            x1="327.707"
            y1="85.1402"
            x2="327.707"
            y2="161.174"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_1886_6847"
            x1="327.49"
            y1="84.9252"
            x2="327.49"
            y2="160.959"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_1886_6847"
            x1="327.275"
            y1="84.7086"
            x2="327.275"
            y2="160.743"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_1886_6847"
            x1="327.06"
            y1="84.492"
            x2="327.06"
            y2="160.526"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint9_linear_1886_6847"
            x1="326.843"
            y1="84.2755"
            x2="326.843"
            y2="160.31"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint10_linear_1886_6847"
            x1="326.628"
            y1="84.0604"
            x2="326.628"
            y2="160.095"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint11_linear_1886_6847"
            x1="326.411"
            y1="83.8439"
            x2="326.411"
            y2="159.878"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint12_linear_1886_6847"
            x1="326.196"
            y1="83.6273"
            x2="326.196"
            y2="159.662"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint13_linear_1886_6847"
            x1="325.981"
            y1="83.4107"
            x2="325.981"
            y2="159.445"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint14_linear_1886_6847"
            x1="325.764"
            y1="83.1957"
            x2="325.764"
            y2="159.23"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint15_linear_1886_6847"
            x1="325.549"
            y1="82.9791"
            x2="325.549"
            y2="159.013"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint16_linear_1886_6847"
            x1="325.335"
            y1="82.7628"
            x2="325.335"
            y2="158.797"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint17_linear_1886_6847"
            x1="325.117"
            y1="82.5462"
            x2="325.117"
            y2="158.58"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint18_linear_1886_6847"
            x1="324.902"
            y1="82.3312"
            x2="324.902"
            y2="158.365"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint19_linear_1886_6847"
            x1="324.688"
            y1="82.1146"
            x2="324.688"
            y2="158.149"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint20_linear_1886_6847"
            x1="324.47"
            y1="81.898"
            x2="324.47"
            y2="157.932"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint21_linear_1886_6847"
            x1="324.256"
            y1="81.6815"
            x2="324.256"
            y2="157.716"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint22_linear_1886_6847"
            x1="324.038"
            y1="81.4649"
            x2="324.038"
            y2="157.499"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint23_linear_1886_6847"
            x1="323.824"
            y1="81.2499"
            x2="323.824"
            y2="157.284"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint24_linear_1886_6847"
            x1="323.609"
            y1="81.0333"
            x2="323.609"
            y2="157.067"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint25_linear_1886_6847"
            x1="323.391"
            y1="80.8168"
            x2="323.391"
            y2="156.851"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint26_linear_1886_6847"
            x1="267.637"
            y1="114.801"
            x2="379.146"
            y2="114.801"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFCACA" />
            <stop offset="0.06" stopColor="#FFC6C6" />
            <stop offset="0.67" stopColor="#FFA1A1" />
            <stop offset="1" stopColor="#FF9494" />
          </linearGradient>
          <linearGradient
            id="paint27_linear_1886_6847"
            x1="286.876"
            y1="76.7521"
            x2="361.157"
            y2="133.529"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.15" stopColor="#BA1515" />
            <stop offset="0.22" stopColor="#BB1815" />
            <stop offset="0.28" stopColor="#C02216" />
            <stop offset="0.34" stopColor="#C83317" />
            <stop offset="0.39" stopColor="#D34B19" />
            <stop offset="0.44" stopColor="#E26A1C" />
            <stop offset="0.49" stopColor="#F48F20" />
            <stop offset="0.52" stopColor="#FFA522" />
            <stop offset="0.55" stopColor="#F48F20" />
            <stop offset="0.61" stopColor="#E2691C" />
            <stop offset="0.68" stopColor="#D34B19" />
            <stop offset="0.75" stopColor="#C83317" />
            <stop offset="0.82" stopColor="#C02216" />
            <stop offset="0.9" stopColor="#BB1815" />
            <stop offset="1" stopColor="#BA1515" />
          </linearGradient>
          <linearGradient
            id="paint28_linear_1886_6847"
            x1="323.391"
            y1="74.9793"
            x2="323.391"
            y2="157.002"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.09" stopColor="#630000" />
            <stop offset="1" stopColor="#BA1515" />
          </linearGradient>
          <linearGradient
            id="paint29_linear_1886_6847"
            x1="227.679"
            y1="85.004"
            x2="227.679"
            y2="161.536"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint30_linear_1886_6847"
            x1="227.465"
            y1="84.7889"
            x2="227.465"
            y2="161.321"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint31_linear_1886_6847"
            x1="227.25"
            y1="84.5723"
            x2="227.25"
            y2="161.105"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint32_linear_1886_6847"
            x1="227.032"
            y1="84.3558"
            x2="227.032"
            y2="160.888"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint33_linear_1886_6847"
            x1="226.818"
            y1="84.1407"
            x2="226.818"
            y2="160.673"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint34_linear_1886_6847"
            x1="226.603"
            y1="83.9241"
            x2="226.603"
            y2="160.456"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint35_linear_1886_6847"
            x1="226.386"
            y1="83.709"
            x2="226.386"
            y2="160.241"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint36_linear_1886_6847"
            x1="226.171"
            y1="83.491"
            x2="226.171"
            y2="160.023"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint37_linear_1886_6847"
            x1="225.956"
            y1="83.2759"
            x2="225.956"
            y2="159.808"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint38_linear_1886_6847"
            x1="225.739"
            y1="83.0594"
            x2="225.739"
            y2="159.592"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint39_linear_1886_6847"
            x1="225.524"
            y1="82.8428"
            x2="225.524"
            y2="159.375"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint40_linear_1886_6847"
            x1="225.307"
            y1="82.6263"
            x2="225.307"
            y2="159.158"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint41_linear_1886_6847"
            x1="225.092"
            y1="82.4112"
            x2="225.092"
            y2="158.943"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint42_linear_1886_6847"
            x1="224.878"
            y1="82.1946"
            x2="224.878"
            y2="158.727"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint43_linear_1886_6847"
            x1="224.66"
            y1="81.9781"
            x2="224.66"
            y2="158.51"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint44_linear_1886_6847"
            x1="224.445"
            y1="81.7618"
            x2="224.445"
            y2="158.294"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint45_linear_1886_6847"
            x1="224.231"
            y1="81.5464"
            x2="224.231"
            y2="158.079"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint46_linear_1886_6847"
            x1="224.013"
            y1="81.3299"
            x2="224.013"
            y2="157.862"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint47_linear_1886_6847"
            x1="223.799"
            y1="81.1136"
            x2="223.799"
            y2="157.646"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint48_linear_1886_6847"
            x1="223.584"
            y1="80.897"
            x2="223.584"
            y2="157.429"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint49_linear_1886_6847"
            x1="223.367"
            y1="80.6805"
            x2="223.367"
            y2="157.213"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint50_linear_1886_6847"
            x1="223.152"
            y1="80.4654"
            x2="223.152"
            y2="156.998"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint51_linear_1886_6847"
            x1="222.934"
            y1="80.2488"
            x2="222.934"
            y2="156.781"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint52_linear_1886_6847"
            x1="222.72"
            y1="80.0323"
            x2="222.72"
            y2="156.565"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint53_linear_1886_6847"
            x1="222.505"
            y1="79.8157"
            x2="222.505"
            y2="156.348"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint54_linear_1886_6847"
            x1="222.288"
            y1="79.6004"
            x2="222.288"
            y2="156.133"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint55_linear_1886_6847"
            x1="181.998"
            y1="113.808"
            x2="262.578"
            y2="113.808"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFCACA" />
            <stop offset="0.06" stopColor="#FFC6C6" />
            <stop offset="0.67" stopColor="#FFA1A1" />
            <stop offset="1" stopColor="#FF9494" />
          </linearGradient>
          <linearGradient
            id="paint56_linear_1886_6847"
            x1="192.439"
            y1="80.8592"
            x2="248.121"
            y2="142.019"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.15" stopColor="#BA1515" />
            <stop offset="0.22" stopColor="#BB1815" />
            <stop offset="0.28" stopColor="#C02216" />
            <stop offset="0.34" stopColor="#C83317" />
            <stop offset="0.39" stopColor="#D34B19" />
            <stop offset="0.44" stopColor="#E26A1C" />
            <stop offset="0.49" stopColor="#F48F20" />
            <stop offset="0.52" stopColor="#FFA522" />
            <stop offset="0.55" stopColor="#F48F20" />
            <stop offset="0.61" stopColor="#E2691C" />
            <stop offset="0.68" stopColor="#D34B19" />
            <stop offset="0.75" stopColor="#C83317" />
            <stop offset="0.82" stopColor="#C02216" />
            <stop offset="0.9" stopColor="#BB1815" />
            <stop offset="1" stopColor="#BA1515" />
          </linearGradient>
          <linearGradient
            id="paint57_linear_1886_6847"
            x1="217.502"
            y1="73.7904"
            x2="217.502"
            y2="152.895"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.09" stopColor="#630000" />
            <stop offset="1" stopColor="#BA1515" />
          </linearGradient>
          <linearGradient
            id="paint58_linear_1886_6847"
            x1="135.879"
            y1="-726.962"
            x2="135.879"
            y2="-726.962"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B91414" />
            <stop offset="0.47" stopColor="#7E0909" />
            <stop offset="0.82" stopColor="#590202" />
            <stop offset="1" stopColor="#4C0000" />
          </linearGradient>
          <linearGradient
            id="paint59_linear_1886_6847"
            x1="135.662"
            y1="85.006"
            x2="135.662"
            y2="161.04"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint60_linear_1886_6847"
            x1="135.447"
            y1="84.7894"
            x2="135.447"
            y2="160.824"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint61_linear_1886_6847"
            x1="135.233"
            y1="79.5795"
            x2="135.233"
            y2="163.31"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B91414" />
            <stop offset="0.47" stopColor="#7E0909" />
            <stop offset="0.82" stopColor="#590202" />
            <stop offset="1" stopColor="#4C0000" />
          </linearGradient>
          <linearGradient
            id="paint62_linear_1886_6847"
            x1="135.015"
            y1="84.3578"
            x2="135.015"
            y2="160.392"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint63_linear_1886_6847"
            x1="134.798"
            y1="84.1412"
            x2="134.798"
            y2="160.175"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint64_linear_1886_6847"
            x1="134.583"
            y1="83.9247"
            x2="134.583"
            y2="159.959"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint65_linear_1886_6847"
            x1="134.368"
            y1="83.7096"
            x2="134.368"
            y2="159.744"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint66_linear_1886_6847"
            x1="134.151"
            y1="78.4984"
            x2="134.151"
            y2="162.229"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B91414" />
            <stop offset="0.47" stopColor="#7E0909" />
            <stop offset="0.82" stopColor="#590202" />
            <stop offset="1" stopColor="#4C0000" />
          </linearGradient>
          <linearGradient
            id="paint67_linear_1886_6847"
            x1="133.936"
            y1="83.2765"
            x2="133.936"
            y2="159.311"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint68_linear_1886_6847"
            x1="133.722"
            y1="83.0599"
            x2="133.722"
            y2="159.094"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint69_linear_1886_6847"
            x1="133.504"
            y1="82.8436"
            x2="133.504"
            y2="158.878"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint70_linear_1886_6847"
            x1="133.289"
            y1="82.6283"
            x2="133.289"
            y2="158.662"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint71_linear_1886_6847"
            x1="133.072"
            y1="77.4171"
            x2="133.072"
            y2="161.148"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B91414" />
            <stop offset="0.47" stopColor="#7E0909" />
            <stop offset="0.82" stopColor="#590202" />
            <stop offset="1" stopColor="#4C0000" />
          </linearGradient>
          <linearGradient
            id="paint72_linear_1886_6847"
            x1="132.86"
            y1="82.1954"
            x2="132.86"
            y2="158.23"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint73_linear_1886_6847"
            x1="132.643"
            y1="81.9789"
            x2="132.643"
            y2="158.013"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint74_linear_1886_6847"
            x1="132.425"
            y1="81.7638"
            x2="132.425"
            y2="157.798"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint75_linear_1886_6847"
            x1="132.211"
            y1="81.5472"
            x2="132.211"
            y2="157.581"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint76_linear_1886_6847"
            x1="131.996"
            y1="76.3373"
            x2="131.996"
            y2="160.068"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B91414" />
            <stop offset="0.47" stopColor="#7E0909" />
            <stop offset="0.82" stopColor="#590202" />
            <stop offset="1" stopColor="#4C0000" />
          </linearGradient>
          <linearGradient
            id="paint77_linear_1886_6847"
            x1="131.778"
            y1="81.1141"
            x2="131.778"
            y2="157.148"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint78_linear_1886_6847"
            x1="131.564"
            y1="80.899"
            x2="131.564"
            y2="156.933"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint79_linear_1886_6847"
            x1="131.349"
            y1="80.6825"
            x2="131.349"
            y2="156.717"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint80_linear_1886_6847"
            x1="131.134"
            y1="80.4659"
            x2="131.134"
            y2="156.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint81_linear_1886_6847"
            x1="130.917"
            y1="75.256"
            x2="130.917"
            y2="158.987"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B91414" />
            <stop offset="0.47" stopColor="#7E0909" />
            <stop offset="0.82" stopColor="#590202" />
            <stop offset="1" stopColor="#4C0000" />
          </linearGradient>
          <linearGradient
            id="paint82_linear_1886_6847"
            x1="130.7"
            y1="80.0343"
            x2="130.7"
            y2="156.068"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint83_linear_1886_6847"
            x1="130.488"
            y1="79.8177"
            x2="130.488"
            y2="155.852"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint84_linear_1886_6847"
            x1="97.4659"
            y1="-726.962"
            x2="163.508"
            y2="-726.962"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFCACA" />
            <stop offset="0.06" stopColor="#FFC6C6" />
            <stop offset="0.67" stopColor="#FFA1A1" />
            <stop offset="1" stopColor="#FF9494" />
          </linearGradient>
          <linearGradient
            id="paint85_linear_1886_6847"
            x1="99.878"
            y1="76.5315"
            x2="161.542"
            y2="151.278"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#BA1515" />
            <stop offset="0.22" stopColor="#BB1815" />
            <stop offset="0.28" stopColor="#C02216" />
            <stop offset="0.34" stopColor="#C83317" />
            <stop offset="0.39" stopColor="#D34B19" />
            <stop offset="0.44" stopColor="#E26A1C" />
            <stop offset="0.49" stopColor="#F48F20" />
            <stop offset="0.52" stopColor="#FFA522" />
            <stop offset="0.55" stopColor="#F48F20" />
            <stop offset="0.61" stopColor="#E2691C" />
            <stop offset="0.68" stopColor="#D34B19" />
            <stop offset="0.75" stopColor="#C83317" />
            <stop offset="0.82" stopColor="#C02216" />
            <stop offset="0.9" stopColor="#BB1815" />
            <stop offset="1" stopColor="#BA1515" />
          </linearGradient>
          <linearGradient
            id="paint86_linear_1886_6847"
            x1="130.484"
            y1="76.445"
            x2="130.484"
            y2="152.609"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.09" stopColor="#630000" />
            <stop offset="1" stopColor="#BA1515" />
          </linearGradient>
          <linearGradient
            id="paint87_linear_1886_6847"
            x1="-271.841"
            y1="84.5736"
            x2="-269.674"
            y2="160.608"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B91414" />
            <stop offset="0.47" stopColor="#7E0909" />
            <stop offset="0.82" stopColor="#590202" />
            <stop offset="1" stopColor="#4C0000" />
          </linearGradient>
          <linearGradient
            id="paint88_linear_1886_6847"
            x1="52.8403"
            y1="84.1159"
            x2="52.8403"
            y2="160.669"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint89_linear_1886_6847"
            x1="52.6257"
            y1="83.8993"
            x2="52.6257"
            y2="160.452"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint90_linear_1886_6847"
            x1="52.4082"
            y1="83.6827"
            x2="52.4082"
            y2="160.236"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint91_linear_1886_6847"
            x1="52.1936"
            y1="83.4662"
            x2="52.1936"
            y2="160.019"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint92_linear_1886_6847"
            x1="51.9789"
            y1="83.2511"
            x2="51.9789"
            y2="159.804"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint93_linear_1886_6847"
            x1="51.7614"
            y1="83.0346"
            x2="51.7614"
            y2="159.588"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint94_linear_1886_6847"
            x1="51.544"
            y1="82.818"
            x2="51.544"
            y2="159.371"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint95_linear_1886_6847"
            x1="51.3321"
            y1="82.6029"
            x2="51.3321"
            y2="159.156"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint96_linear_1886_6847"
            x1="51.1147"
            y1="82.3851"
            x2="51.1147"
            y2="158.938"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint97_linear_1886_6847"
            x1="50.9"
            y1="82.1698"
            x2="50.9"
            y2="158.723"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint98_linear_1886_6847"
            x1="50.6826"
            y1="81.9533"
            x2="50.6826"
            y2="158.506"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint99_linear_1886_6847"
            x1="50.4679"
            y1="81.7369"
            x2="50.4679"
            y2="158.29"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint100_linear_1886_6847"
            x1="50.2533"
            y1="81.5204"
            x2="50.2533"
            y2="158.073"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint101_linear_1886_6847"
            x1="50.0358"
            y1="81.3053"
            x2="50.0358"
            y2="157.858"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint102_linear_1886_6847"
            x1="49.8211"
            y1="81.0888"
            x2="49.8211"
            y2="157.642"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint103_linear_1886_6847"
            x1="49.6065"
            y1="80.8722"
            x2="49.6065"
            y2="157.425"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint104_linear_1886_6847"
            x1="49.3891"
            y1="80.6571"
            x2="49.3891"
            y2="157.21"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint105_linear_1886_6847"
            x1="49.1744"
            y1="80.4406"
            x2="49.1744"
            y2="156.993"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint106_linear_1886_6847"
            x1="48.9569"
            y1="80.224"
            x2="48.9569"
            y2="156.777"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint107_linear_1886_6847"
            x1="48.7423"
            y1="80.0075"
            x2="48.7423"
            y2="156.56"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint108_linear_1886_6847"
            x1="48.5276"
            y1="79.7924"
            x2="48.5276"
            y2="156.345"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint109_linear_1886_6847"
            x1="48.3101"
            y1="79.5758"
            x2="48.3101"
            y2="156.129"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint110_linear_1886_6847"
            x1="48.0955"
            y1="79.3593"
            x2="48.0955"
            y2="155.912"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint111_linear_1886_6847"
            x1="47.8808"
            y1="79.1427"
            x2="47.8808"
            y2="155.696"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint112_linear_1886_6847"
            x1="47.6634"
            y1="78.9276"
            x2="47.6634"
            y2="155.481"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#008080" />
            <stop offset="0.47" stopColor="#025E5E" />
            <stop offset="0.82" stopColor="#012C2C" />
            <stop offset="1" stopColor="#001C1C" />
          </linearGradient>
          <linearGradient
            id="paint113_linear_1886_6847"
            x1="15.342"
            y1="113.155"
            x2="80.0042"
            y2="113.155"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFCACA" />
            <stop offset="0.06" stopColor="#FFC6C6" />
            <stop offset="0.67" stopColor="#FFA1A1" />
            <stop offset="1" stopColor="#FF9494" />
          </linearGradient>
          <linearGradient
            id="paint114_linear_1886_6847"
            x1="24.2506"
            y1="76.3588"
            x2="73.3667"
            y2="147.464"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.15" stopColor="#BA1515" />
            <stop offset="0.22" stopColor="#BB1815" />
            <stop offset="0.28" stopColor="#C02216" />
            <stop offset="0.34" stopColor="#C83317" />
            <stop offset="0.39" stopColor="#D34B19" />
            <stop offset="0.44" stopColor="#E26A1C" />
            <stop offset="0.49" stopColor="#F48F20" />
            <stop offset="0.52" stopColor="#FFA522" />
            <stop offset="0.55" stopColor="#F48F20" />
            <stop offset="0.61" stopColor="#E2691C" />
            <stop offset="0.68" stopColor="#D34B19" />
            <stop offset="0.75" stopColor="#C83317" />
            <stop offset="0.82" stopColor="#C02216" />
            <stop offset="0.9" stopColor="#BB1815" />
            <stop offset="1" stopColor="#BA1515" />
          </linearGradient>
          <linearGradient
            id="paint115_linear_1886_6847"
            x1="47.6739"
            y1="75.0839"
            x2="47.6739"
            y2="151.723"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.09" stopColor="#630000" />
            <stop offset="1" stopColor="#BA1515" />
          </linearGradient>
          <radialGradient
            id="paint116_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(17.5251 0.831444 -0.829524 17.5644 37.4574 86.1432)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.2699" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.5799" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint117_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(2.03104 -5.87843 36.327 12.6075 35.7765 86.9977)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint118_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(5.8653 2.03559 -12.5794 36.4083 39.8363 80.6104)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint119_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(5.01646 -3.66357 22.6398 31.1393 31.2959 85.551)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint120_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(3.65539 5.0277 -31.0697 22.6905 42.3576 85.4113)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFE6C1" />
            <stop offset="0.12" stopColor="#FFE6C1" />
            <stop offset="0.13" stopColor="#FFE6C1" />
            <stop offset="0.14" stopColor="#FFE6C1" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#FFE6C1" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#AD6800" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint121_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(22.7281 1.78074 -1.77676 22.7789 66.7135 133.76)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint122_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(2.03104 -5.87843 36.327 12.6075 64.3243 139.924)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint123_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(5.8653 2.03559 -12.5794 36.4083 68.3841 133.537)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint124_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(5.01646 -3.66357 22.6398 31.1393 59.8416 138.478)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint125_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(3.65539 5.0277 -31.0697 22.6905 70.9033 138.339)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint126_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(22.7281 1.78074 -1.77676 22.7789 105.252 110.872)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint127_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(2.03104 -5.87843 36.327 12.6075 102.862 117.036)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint128_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(5.8653 2.03559 -12.5794 36.4083 106.922 110.649)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint129_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(2.03104 -5.87843 36.327 12.6075 210.919 146.742)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint130_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(5.8653 2.03559 -12.5794 36.4083 214.979 140.354)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint131_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(2.03104 -5.87843 36.327 12.6075 152.411 97.1269)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint132_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(5.8653 2.03559 -12.5794 36.4083 156.47 90.7395)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint133_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(5.01646 -3.66357 22.6398 31.1393 98.3804 115.59)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint134_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(3.65539 5.0277 -31.0697 22.6905 109.442 115.451)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFDCA9" />
            <stop offset="0.13" stopColor="#FFDCA9" />
            <stop offset="0.14" stopColor="#FFDCA9" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint135_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(5.01646 -3.66357 22.6398 31.1393 206.438 145.296)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint136_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(3.65539 5.0277 -31.0697 22.6905 217.499 145.156)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFDCA9" />
            <stop offset="0.13" stopColor="#FFDCA9" />
            <stop offset="0.14" stopColor="#FFDCA9" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint137_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(5.01646 -3.66357 22.6398 31.1393 147.929 95.6808)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint138_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(3.65539 5.0277 -31.0697 22.6905 158.991 95.5412)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFDCA9" />
            <stop offset="0.13" stopColor="#FFDCA9" />
            <stop offset="0.14" stopColor="#FFDCA9" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint139_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(22.7281 1.78074 -1.77676 22.7789 243.705 90.8466)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint140_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(2.03104 -5.87843 36.327 12.6075 241.316 97.0111)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint141_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(5.8653 2.03559 -12.5794 36.4083 245.376 90.6238)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint142_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(5.01646 -3.66357 22.6398 31.1393 236.834 95.5644)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint143_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(3.65539 5.0277 -31.0697 22.6905 247.895 95.4247)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="white" />
            <stop offset="0.12" stopColor="#FFE0A9" />
            <stop offset="0.13" stopColor="white" />
            <stop offset="0.14" stopColor="white" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint144_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(22.7281 1.78074 -1.77676 22.7789 300.798 140.913)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint145_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(2.03104 -5.87843 36.327 12.6075 298.408 147.076)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint146_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(5.8653 2.03559 -12.5794 36.4083 302.467 140.689)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint147_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(5.01646 -3.66357 22.6398 31.1393 293.927 145.631)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint148_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(3.65539 5.0277 -31.0697 22.6905 304.989 145.491)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFE0A9" />
            <stop offset="0.13" stopColor="#FFE0A9" />
            <stop offset="0.14" stopColor="#FFE0A9" />
            <stop offset="0.2" stopColor="#FFE0A9" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint149_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(22.7281 1.78074 -1.77676 22.7789 329.345 100.86)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint150_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(2.03104 -5.87843 36.327 12.6075 326.955 107.025)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint151_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(5.8653 2.03559 -12.5794 36.4083 331.015 100.637)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint152_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(5.01646 -3.66357 22.6398 31.1393 322.475 105.578)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint153_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(3.65539 5.0277 -31.0697 22.6905 333.537 105.438)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.01" stopColor="#FFFAF4" />
            <stop offset="0.03" stopColor="#FFEFD7" />
            <stop offset="0.05" stopColor="#FFDCA9" />
            <stop offset="0.08" stopColor="#FFC268" />
            <stop offset="0.12" stopColor="#FFA117" />
            <stop offset="0.13" stopColor="#FF9800" />
            <stop offset="0.14" stopColor="#F18F00" stop-opacity="0.95" />
            <stop offset="0.2" stopColor="#BF7100" stop-opacity="0.75" />
            <stop offset="0.27" stopColor="#915600" stop-opacity="0.57" />
            <stop offset="0.34" stopColor="#6A3F00" stop-opacity="0.42" />
            <stop offset="0.42" stopColor="#492B00" stop-opacity="0.29" />
            <stop offset="0.5" stopColor="#2E1B00" stop-opacity="0.18" />
            <stop offset="0.58" stopColor="#190F00" stop-opacity="0.1" />
            <stop offset="0.68" stopColor="#0B0600" stop-opacity="0.04" />
            <stop offset="0.8" stopColor="#020100" stop-opacity="0.01" />
            <stop offset="0.98" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint154_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(36.7342 83.8004) rotate(-179.989) scale(8.44607 8.46498)"
          >
            <stop stopColor="white" />
            <stop offset="0.173077" stopColor="#FFEBE1" stop-opacity="0.94" />
            <stop offset="0.495192" stopColor="#FFD608" stop-opacity="0.48" />
            <stop offset="1" stopColor="#0F0F0F" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint155_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(38.9846 110.863) rotate(-179.989) scale(8.44607 8.46498)"
          >
            <stop stopColor="white" />
            <stop offset="0.173077" stopColor="#FFEBE1" stop-opacity="0.94" />
            <stop offset="0.495192" stopColor="#FFD608" stop-opacity="0.48" />
            <stop offset="1" stopColor="#0F0F0F" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint156_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(68.2388 123.267) rotate(-179.989) scale(8.44607 8.46498)"
          >
            <stop stopColor="white" />
            <stop offset="0.173077" stopColor="#FFEBE1" stop-opacity="0.94" />
            <stop offset="0.495192" stopColor="#FFD608" stop-opacity="0.48" />
            <stop offset="1" stopColor="#0F0F0F" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint157_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(47.9858 144.692) rotate(-179.989) scale(8.44607 8.46498)"
          >
            <stop stopColor="white" />
            <stop offset="0.173077" stopColor="#FFEBE1" stop-opacity="0.94" />
            <stop offset="0.495192" stopColor="#FFD608" stop-opacity="0.48" />
            <stop offset="1" stopColor="#0F0F0F" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint158_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(28.8581 135.671) rotate(-179.989) scale(8.44607 8.46498)"
          >
            <stop stopColor="white" />
            <stop offset="0.173077" stopColor="#FFEBE1" stop-opacity="0.94" />
            <stop offset="0.495192" stopColor="#FFD608" stop-opacity="0.48" />
            <stop offset="1" stopColor="#0F0F0F" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint159_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(118.871 114.246) rotate(-179.989) scale(8.44607 8.46498)"
          >
            <stop stopColor="white" />
            <stop offset="0.466346" stopColor="#FFE772" stop-opacity="0.88" />
            <stop offset="1" stopColor="#0F0F0F" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint160_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(153.666 115.368) rotate(-179.989) scale(7.23528 7.25105)"
          >
            <stop stopColor="white" />
            <stop offset="0.466346" stopColor="#FFE772" stop-opacity="0.88" />
            <stop offset="1" stopColor="#0F0F0F" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint161_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(153.666 93.9436) rotate(-179.989) scale(7.23528 7.25105)"
          >
            <stop stopColor="white" />
            <stop offset="0.466346" stopColor="#FFE772" stop-opacity="0.88" />
            <stop offset="1" stopColor="#0F0F0F" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint162_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(153.666 83.7952) rotate(-179.989) scale(7.23528 7.25105)"
          >
            <stop stopColor="white" />
            <stop offset="0.466346" stopColor="#FFE772" stop-opacity="0.88" />
            <stop offset="1" stopColor="#0F0F0F" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint163_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(153.666 137.921) rotate(-179.989) scale(7.23528 7.25105)"
          >
            <stop stopColor="white" />
            <stop offset="0.466346" stopColor="#FFE772" stop-opacity="0.88" />
            <stop offset="1" stopColor="#0F0F0F" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint164_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(107.534 136.793) rotate(-179.989) scale(7.23528 7.25105)"
          >
            <stop stopColor="white" />
            <stop offset="0.466346" stopColor="#FFE772" stop-opacity="0.88" />
            <stop offset="1" stopColor="#0F0F0F" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint165_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(67.0283 88.3057) rotate(-179.989) scale(7.23528 7.25105)"
          >
            <stop stopColor="white" />
            <stop offset="0.466346" stopColor="#FFE772" stop-opacity="0.88" />
            <stop offset="1" stopColor="#0F0F0F" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint166_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(203.173 136.793) rotate(-179.989) scale(7.23528 7.25105)"
          >
            <stop stopColor="white" />
            <stop offset="0.466346" stopColor="#FFE772" stop-opacity="0.88" />
            <stop offset="1" stopColor="#0F0F0F" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint167_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(197.547 97.3267) rotate(-179.989) scale(7.23528 7.25105)"
          >
            <stop stopColor="white" />
            <stop offset="0.466346" stopColor="#FFE772" stop-opacity="0.88" />
            <stop offset="1" stopColor="#0F0F0F" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint168_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(224.551 84.9229) rotate(-179.989) scale(7.23528 7.25105)"
          >
            <stop stopColor="white" />
            <stop offset="0.466346" stopColor="#FFE772" stop-opacity="0.88" />
            <stop offset="1" stopColor="#0F0F0F" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint169_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(243.679 133.41) rotate(-179.989) scale(7.23528 7.25105)"
          >
            <stop stopColor="white" />
            <stop offset="0.466346" stopColor="#FFE772" stop-opacity="0.88" />
            <stop offset="1" stopColor="#0F0F0F" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint170_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(249.305 123.262) rotate(-179.989) scale(7.23528 7.25105)"
          >
            <stop stopColor="white" />
            <stop offset="0.466346" stopColor="#FFE772" stop-opacity="0.88" />
            <stop offset="1" stopColor="#0F0F0F" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint171_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(292.061 114.241) rotate(-179.989) scale(7.23528 7.25105)"
          >
            <stop stopColor="white" />
            <stop offset="0.466346" stopColor="#FFE772" stop-opacity="0.88" />
            <stop offset="1" stopColor="#0F0F0F" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint172_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(285.31 95.0713) rotate(-179.989) scale(7.23528 7.25105)"
          >
            <stop stopColor="white" />
            <stop offset="0.466346" stopColor="#FFE772" stop-opacity="0.88" />
            <stop offset="1" stopColor="#0F0F0F" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint173_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(298.812 134.538) rotate(-179.989) scale(7.23528 7.25105)"
          >
            <stop stopColor="white" />
            <stop offset="0.466346" stopColor="#FFE772" stop-opacity="0.88" />
            <stop offset="1" stopColor="#0F0F0F" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint174_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(320.19 95.0713) rotate(-179.989) scale(7.23528 7.25105)"
          >
            <stop stopColor="white" />
            <stop offset="0.466346" stopColor="#FFE772" stop-opacity="0.88" />
            <stop offset="1" stopColor="#0F0F0F" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint175_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(338.193 124.389) rotate(-179.989) scale(7.23528 7.25105)"
          >
            <stop stopColor="white" />
            <stop offset="0.466346" stopColor="#FFE772" stop-opacity="0.88" />
            <stop offset="1" stopColor="#0F0F0F" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint176_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(344.943 144.686) rotate(-179.989) scale(7.23528 7.25105)"
          >
            <stop stopColor="white" />
            <stop offset="0.466346" stopColor="#FFE772" stop-opacity="0.88" />
            <stop offset="1" stopColor="#0F0F0F" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint177_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(355.07 114.241) rotate(-179.989) scale(7.23528 7.25105)"
          >
            <stop stopColor="white" />
            <stop offset="0.466346" stopColor="#FFE772" stop-opacity="0.88" />
            <stop offset="1" stopColor="#0F0F0F" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint178_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(361.821 95.0713) rotate(-179.989) scale(7.23528 7.25105)"
          >
            <stop stopColor="white" />
            <stop offset="0.466346" stopColor="#FFE772" stop-opacity="0.88" />
            <stop offset="1" stopColor="#0F0F0F" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint179_radial_1886_6847"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(365.196 84.9229) rotate(-179.989) scale(7.23528 7.25105)"
          >
            <stop stopColor="white" />
            <stop offset="0.466346" stopColor="#FFE772" stop-opacity="0.88" />
            <stop offset="1" stopColor="#0F0F0F" stop-opacity="0" />
          </radialGradient>
          <image
            id="image0_1886_6847"
            width="115"
            height="104"
            preserveAspectRatio="none"
          />
          <image
            id="image1_1886_6847"
            width="104"
            height="104"
            preserveAspectRatio="none"
          />
          <image
            id="image2_1886_6847"
            width="98"
            height="105"
            preserveAspectRatio="none"
          />
          <image
            id="image3_1886_6847"
            width="95"
            height="105"
            preserveAspectRatio="none"
          />
        </defs>
      </svg>
    </>
  );
}
